/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as ReleasesRouteImport } from './routes/releases'
import { Route as PasswordResetRouteImport } from './routes/password-reset'
import { Route as AcceptInvitationRouteImport } from './routes/accept-invitation'
import { Route as ReferrerRouteRouteImport } from './routes/referrer/route'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ReferrerLayoutRouteImport } from './routes/referrer/_layout'
import { Route as AdminLayoutRouteImport } from './routes/admin/_layout'
import { Route as ReferrerLayoutReleasesRouteImport } from './routes/referrer/_layout/releases'
import { Route as ReferrerLayoutInfrastructureCostsRouteImport } from './routes/referrer/_layout/infrastructure-costs'
import { Route as ReferrerLayoutDashboardRouteImport } from './routes/referrer/_layout/dashboard'
import { Route as AdminLayoutDashboardRouteImport } from './routes/admin/_layout/dashboard'
import { Route as AdminLayoutReleasesIndexRouteImport } from './routes/admin/_layout/releases/index'
import { Route as AdminLayoutInfrastructureCostsIndexRouteImport } from './routes/admin/_layout/infrastructure-costs/index'
import { Route as AdminLayoutAiUsageIndexRouteImport } from './routes/admin/_layout/ai-usage/index'
import { Route as ReferrerLayoutTenantsLayoutRouteImport } from './routes/referrer/_layout/tenants/_layout'
import { Route as ReferrerLayoutContractsLayoutRouteImport } from './routes/referrer/_layout/contracts/_layout'
import { Route as ReferrerLayoutCommissionsLayoutRouteImport } from './routes/referrer/_layout/commissions/_layout'
import { Route as ReferrerLayoutAgentsLayoutRouteImport } from './routes/referrer/_layout/agents/_layout'
import { Route as AdminLayoutTicketsLayoutRouteImport } from './routes/admin/_layout/tickets/_layout'
import { Route as AdminLayoutTenantsLayoutRouteImport } from './routes/admin/_layout/tenants/_layout'
import { Route as AdminLayoutSystemMonitorLayoutRouteImport } from './routes/admin/_layout/system-monitor/_layout'
import { Route as AdminLayoutServiceUsageByServiceRouteImport } from './routes/admin/_layout/service-usage/by-service'
import { Route as AdminLayoutServiceUsageLayoutRouteImport } from './routes/admin/_layout/service-usage/_layout'
import { Route as AdminLayoutReferrersLayoutRouteImport } from './routes/admin/_layout/referrers/_layout'
import { Route as AdminLayoutNotificationsLayoutRouteImport } from './routes/admin/_layout/notifications/_layout'
import { Route as AdminLayoutMcpClientsLayoutRouteImport } from './routes/admin/_layout/mcp-clients/_layout'
import { Route as AdminLayoutForeignVendorsLayoutRouteImport } from './routes/admin/_layout/foreign-vendors/_layout'
import { Route as AdminLayoutErrorLogsLayoutRouteImport } from './routes/admin/_layout/error-logs/_layout'
import { Route as AdminLayoutContractsLayoutRouteImport } from './routes/admin/_layout/contracts/_layout'
import { Route as AdminLayoutCommissionsLayoutRouteImport } from './routes/admin/_layout/commissions/_layout'
import { Route as AdminLayoutAppointeeLayoutRouteImport } from './routes/admin/_layout/appointee/_layout'
import { Route as AdminLayoutAdvisorsLayoutRouteImport } from './routes/admin/_layout/advisors/_layout'
import { Route as AdminLayoutAdminsLayoutRouteImport } from './routes/admin/_layout/admins/_layout'
import { Route as AdminLayoutAcubePaymentsLayoutRouteImport } from './routes/admin/_layout/acube-payments/_layout'
import { Route as AdminLayoutAcubeJobsLayoutRouteImport } from './routes/admin/_layout/acube-jobs/_layout'
import { Route as ReferrerLayoutTenantsLayoutIndexRouteImport } from './routes/referrer/_layout/tenants/_layout/index'
import { Route as ReferrerLayoutContractsLayoutIndexRouteImport } from './routes/referrer/_layout/contracts/_layout/index'
import { Route as ReferrerLayoutCommissionsLayoutIndexRouteImport } from './routes/referrer/_layout/commissions/_layout/index'
import { Route as ReferrerLayoutAgentsLayoutIndexRouteImport } from './routes/referrer/_layout/agents/_layout/index'
import { Route as AdminLayoutTicketsLayoutIndexRouteImport } from './routes/admin/_layout/tickets/_layout/index'
import { Route as AdminLayoutTenantsLayoutIndexRouteImport } from './routes/admin/_layout/tenants/_layout/index'
import { Route as AdminLayoutSystemMonitorLayoutIndexRouteImport } from './routes/admin/_layout/system-monitor/_layout/index'
import { Route as AdminLayoutServiceUsageLayoutIndexRouteImport } from './routes/admin/_layout/service-usage/_layout/index'
import { Route as AdminLayoutReferrersLayoutIndexRouteImport } from './routes/admin/_layout/referrers/_layout/index'
import { Route as AdminLayoutNotificationsLayoutIndexRouteImport } from './routes/admin/_layout/notifications/_layout/index'
import { Route as AdminLayoutMcpClientsLayoutIndexRouteImport } from './routes/admin/_layout/mcp-clients/_layout/index'
import { Route as AdminLayoutForeignVendorsLayoutIndexRouteImport } from './routes/admin/_layout/foreign-vendors/_layout/index'
import { Route as AdminLayoutErrorLogsLayoutIndexRouteImport } from './routes/admin/_layout/error-logs/_layout/index'
import { Route as AdminLayoutContractsLayoutIndexRouteImport } from './routes/admin/_layout/contracts/_layout/index'
import { Route as AdminLayoutCommissionsLayoutIndexRouteImport } from './routes/admin/_layout/commissions/_layout/index'
import { Route as AdminLayoutAppointeeLayoutIndexRouteImport } from './routes/admin/_layout/appointee/_layout/index'
import { Route as AdminLayoutAdvisorsLayoutIndexRouteImport } from './routes/admin/_layout/advisors/_layout/index'
import { Route as AdminLayoutAdminsLayoutIndexRouteImport } from './routes/admin/_layout/admins/_layout/index'
import { Route as AdminLayoutAcubePaymentsLayoutIndexRouteImport } from './routes/admin/_layout/acube-payments/_layout/index'
import { Route as AdminLayoutAcubeJobsLayoutIndexRouteImport } from './routes/admin/_layout/acube-jobs/_layout/index'
import { Route as ReferrerLayoutTenantsLayoutIdRouteImport } from './routes/referrer/_layout/tenants/_layout/$id'
import { Route as ReferrerLayoutContractsLayoutNewRouteImport } from './routes/referrer/_layout/contracts/_layout/new'
import { Route as ReferrerLayoutContractsLayoutIdRouteImport } from './routes/referrer/_layout/contracts/_layout/$id'
import { Route as ReferrerLayoutCommissionsLayoutIdRouteImport } from './routes/referrer/_layout/commissions/_layout/$id'
import { Route as ReferrerLayoutAgentsLayoutNewRouteImport } from './routes/referrer/_layout/agents/_layout/new'
import { Route as ReferrerLayoutAgentsLayoutIdRouteImport } from './routes/referrer/_layout/agents/_layout/$id'
import { Route as AdminLayoutTicketsLayoutIdRouteImport } from './routes/admin/_layout/tickets/_layout/$id'
import { Route as AdminLayoutTenantsLayoutIdRouteImport } from './routes/admin/_layout/tenants/_layout/$id'
import { Route as AdminLayoutSystemMonitorLayoutRedisRouteImport } from './routes/admin/_layout/system-monitor/_layout/redis'
import { Route as AdminLayoutSystemMonitorLayoutQueuesRouteImport } from './routes/admin/_layout/system-monitor/_layout/queues'
import { Route as AdminLayoutSystemMonitorLayoutOverviewRouteImport } from './routes/admin/_layout/system-monitor/_layout/overview'
import { Route as AdminLayoutSystemMonitorLayoutMetricsRouteImport } from './routes/admin/_layout/system-monitor/_layout/metrics'
import { Route as AdminLayoutServiceUsageLayoutTenantIdRouteImport } from './routes/admin/_layout/service-usage/_layout/$tenantId'
import { Route as AdminLayoutReferrersLayoutNewPartnerRouteImport } from './routes/admin/_layout/referrers/_layout/new-partner'
import { Route as AdminLayoutReferrersLayoutNewRouteImport } from './routes/admin/_layout/referrers/_layout/new'
import { Route as AdminLayoutReferrersLayoutIdRouteImport } from './routes/admin/_layout/referrers/_layout/$id'
import { Route as AdminLayoutNotificationsLayoutIdRouteImport } from './routes/admin/_layout/notifications/_layout/$id'
import { Route as AdminLayoutMcpClientsLayoutIdRouteImport } from './routes/admin/_layout/mcp-clients/_layout/$id'
import { Route as AdminLayoutForeignVendorsLayoutNewRouteImport } from './routes/admin/_layout/foreign-vendors/_layout/new'
import { Route as AdminLayoutErrorLogsLayoutIdRouteImport } from './routes/admin/_layout/error-logs/_layout/$id'
import { Route as AdminLayoutContractsLayoutNewRouteImport } from './routes/admin/_layout/contracts/_layout/new'
import { Route as AdminLayoutContractsLayoutIdRouteImport } from './routes/admin/_layout/contracts/_layout/$id'
import { Route as AdminLayoutCommissionsLayoutIdRouteImport } from './routes/admin/_layout/commissions/_layout/$id'
import { Route as AdminLayoutAppointeeLayoutCredentialsRouteImport } from './routes/admin/_layout/appointee/_layout/credentials'
import { Route as AdminLayoutAppointeeLayoutIdRouteImport } from './routes/admin/_layout/appointee/_layout/$id'
import { Route as AdminLayoutAdvisorsLayoutNewRouteImport } from './routes/admin/_layout/advisors/_layout/new'
import { Route as AdminLayoutAdvisorsLayoutIdRouteImport } from './routes/admin/_layout/advisors/_layout/$id'
import { Route as AdminLayoutAdminsLayoutNewRouteImport } from './routes/admin/_layout/admins/_layout/new'
import { Route as AdminLayoutAcubePaymentsLayoutIdRouteImport } from './routes/admin/_layout/acube-payments/_layout/$id'
import { Route as AdminLayoutAcubeJobsLayoutIdRouteImport } from './routes/admin/_layout/acube-jobs/_layout/$id'
import { Route as ReferrerLayoutContractsLayoutIdEditRouteImport } from './routes/referrer/_layout/contracts/_layout/$id_.edit'
import { Route as AdminLayoutSystemMonitorLayoutRunsLayoutRouteImport } from './routes/admin/_layout/system-monitor/_layout/runs/_layout'
import { Route as AdminLayoutSystemMonitorLayoutJobJobIdRouteImport } from './routes/admin/_layout/system-monitor/_layout/job.$jobId'
import { Route as AdminLayoutSystemMonitorLayoutFlowFlowIdRouteImport } from './routes/admin/_layout/system-monitor/_layout/flow.$flowId'
import { Route as AdminLayoutReferrersLayoutEditIdRouteImport } from './routes/admin/_layout/referrers/_layout/edit.$id'
import { Route as AdminLayoutNotificationsLayoutEditIdRouteImport } from './routes/admin/_layout/notifications/_layout/edit.$id'
import { Route as AdminLayoutForeignVendorsLayoutEditIdRouteImport } from './routes/admin/_layout/foreign-vendors/_layout/edit.$id'
import { Route as AdminLayoutContractsLayoutIdEditRouteImport } from './routes/admin/_layout/contracts/_layout/$id_.edit'
import { Route as AdminLayoutAdvisorsLayoutEditIdRouteImport } from './routes/admin/_layout/advisors/_layout/edit.$id'
import { Route as AdminLayoutAdminsLayoutEditIdRouteImport } from './routes/admin/_layout/admins/_layout/edit.$id'
import { Route as AdminLayoutAcubePaymentsLayoutSepaIdRouteImport } from './routes/admin/_layout/acube-payments/_layout/sepa.$id'
import { Route as AdminLayoutSystemMonitorLayoutRunsLayoutIndexRouteImport } from './routes/admin/_layout/system-monitor/_layout/runs/_layout/index'
import { Route as AdminLayoutSystemMonitorLayoutRunsLayoutIdRouteImport } from './routes/admin/_layout/system-monitor/_layout/runs/_layout/$id'

const ReferrerLayoutTenantsRouteImport = createFileRoute(
  '/referrer/_layout/tenants',
)()
const ReferrerLayoutContractsRouteImport = createFileRoute(
  '/referrer/_layout/contracts',
)()
const ReferrerLayoutCommissionsRouteImport = createFileRoute(
  '/referrer/_layout/commissions',
)()
const ReferrerLayoutAgentsRouteImport = createFileRoute(
  '/referrer/_layout/agents',
)()
const AdminLayoutTicketsRouteImport = createFileRoute(
  '/admin/_layout/tickets',
)()
const AdminLayoutTenantsRouteImport = createFileRoute(
  '/admin/_layout/tenants',
)()
const AdminLayoutSystemMonitorRouteImport = createFileRoute(
  '/admin/_layout/system-monitor',
)()
const AdminLayoutServiceUsageRouteImport = createFileRoute(
  '/admin/_layout/service-usage',
)()
const AdminLayoutReferrersRouteImport = createFileRoute(
  '/admin/_layout/referrers',
)()
const AdminLayoutNotificationsRouteImport = createFileRoute(
  '/admin/_layout/notifications',
)()
const AdminLayoutMcpClientsRouteImport = createFileRoute(
  '/admin/_layout/mcp-clients',
)()
const AdminLayoutForeignVendorsRouteImport = createFileRoute(
  '/admin/_layout/foreign-vendors',
)()
const AdminLayoutErrorLogsRouteImport = createFileRoute(
  '/admin/_layout/error-logs',
)()
const AdminLayoutContractsRouteImport = createFileRoute(
  '/admin/_layout/contracts',
)()
const AdminLayoutCommissionsRouteImport = createFileRoute(
  '/admin/_layout/commissions',
)()
const AdminLayoutAppointeeRouteImport = createFileRoute(
  '/admin/_layout/appointee',
)()
const AdminLayoutAdvisorsRouteImport = createFileRoute(
  '/admin/_layout/advisors',
)()
const AdminLayoutAdminsRouteImport = createFileRoute('/admin/_layout/admins')()
const AdminLayoutAcubePaymentsRouteImport = createFileRoute(
  '/admin/_layout/acube-payments',
)()
const AdminLayoutAcubeJobsRouteImport = createFileRoute(
  '/admin/_layout/acube-jobs',
)()
const AdminLayoutSystemMonitorLayoutRunsRouteImport = createFileRoute(
  '/admin/_layout/system-monitor/_layout/runs',
)()

const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const ReleasesRoute = ReleasesRouteImport.update({
  id: '/releases',
  path: '/releases',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetRoute = PasswordResetRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const ReferrerRouteRoute = ReferrerRouteRouteImport.update({
  id: '/referrer',
  path: '/referrer',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReferrerLayoutRoute = ReferrerLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => ReferrerRouteRoute,
} as any)
const AdminLayoutRoute = AdminLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => AdminRouteRoute,
} as any)
const ReferrerLayoutTenantsRoute = ReferrerLayoutTenantsRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => ReferrerLayoutRoute,
} as any)
const ReferrerLayoutContractsRoute = ReferrerLayoutContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => ReferrerLayoutRoute,
} as any)
const ReferrerLayoutCommissionsRoute =
  ReferrerLayoutCommissionsRouteImport.update({
    id: '/commissions',
    path: '/commissions',
    getParentRoute: () => ReferrerLayoutRoute,
  } as any)
const ReferrerLayoutAgentsRoute = ReferrerLayoutAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => ReferrerLayoutRoute,
} as any)
const AdminLayoutTicketsRoute = AdminLayoutTicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutTenantsRoute = AdminLayoutTenantsRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutSystemMonitorRoute =
  AdminLayoutSystemMonitorRouteImport.update({
    id: '/system-monitor',
    path: '/system-monitor',
    getParentRoute: () => AdminLayoutRoute,
  } as any)
const AdminLayoutServiceUsageRoute = AdminLayoutServiceUsageRouteImport.update({
  id: '/service-usage',
  path: '/service-usage',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutReferrersRoute = AdminLayoutReferrersRouteImport.update({
  id: '/referrers',
  path: '/referrers',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutNotificationsRoute =
  AdminLayoutNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AdminLayoutRoute,
  } as any)
const AdminLayoutMcpClientsRoute = AdminLayoutMcpClientsRouteImport.update({
  id: '/mcp-clients',
  path: '/mcp-clients',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutForeignVendorsRoute =
  AdminLayoutForeignVendorsRouteImport.update({
    id: '/foreign-vendors',
    path: '/foreign-vendors',
    getParentRoute: () => AdminLayoutRoute,
  } as any)
const AdminLayoutErrorLogsRoute = AdminLayoutErrorLogsRouteImport.update({
  id: '/error-logs',
  path: '/error-logs',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutContractsRoute = AdminLayoutContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutCommissionsRoute = AdminLayoutCommissionsRouteImport.update({
  id: '/commissions',
  path: '/commissions',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutAppointeeRoute = AdminLayoutAppointeeRouteImport.update({
  id: '/appointee',
  path: '/appointee',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutAdvisorsRoute = AdminLayoutAdvisorsRouteImport.update({
  id: '/advisors',
  path: '/advisors',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutAdminsRoute = AdminLayoutAdminsRouteImport.update({
  id: '/admins',
  path: '/admins',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutAcubePaymentsRoute =
  AdminLayoutAcubePaymentsRouteImport.update({
    id: '/acube-payments',
    path: '/acube-payments',
    getParentRoute: () => AdminLayoutRoute,
  } as any)
const AdminLayoutAcubeJobsRoute = AdminLayoutAcubeJobsRouteImport.update({
  id: '/acube-jobs',
  path: '/acube-jobs',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const ReferrerLayoutReleasesRoute = ReferrerLayoutReleasesRouteImport.update({
  id: '/releases',
  path: '/releases',
  getParentRoute: () => ReferrerLayoutRoute,
} as any)
const ReferrerLayoutInfrastructureCostsRoute =
  ReferrerLayoutInfrastructureCostsRouteImport.update({
    id: '/infrastructure-costs',
    path: '/infrastructure-costs',
    getParentRoute: () => ReferrerLayoutRoute,
  } as any)
const ReferrerLayoutDashboardRoute = ReferrerLayoutDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ReferrerLayoutRoute,
} as any)
const AdminLayoutDashboardRoute = AdminLayoutDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutReleasesIndexRoute =
  AdminLayoutReleasesIndexRouteImport.update({
    id: '/releases/',
    path: '/releases/',
    getParentRoute: () => AdminLayoutRoute,
  } as any)
const AdminLayoutInfrastructureCostsIndexRoute =
  AdminLayoutInfrastructureCostsIndexRouteImport.update({
    id: '/infrastructure-costs/',
    path: '/infrastructure-costs/',
    getParentRoute: () => AdminLayoutRoute,
  } as any)
const AdminLayoutAiUsageIndexRoute = AdminLayoutAiUsageIndexRouteImport.update({
  id: '/ai-usage/',
  path: '/ai-usage/',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const ReferrerLayoutTenantsLayoutRoute =
  ReferrerLayoutTenantsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ReferrerLayoutTenantsRoute,
  } as any)
const ReferrerLayoutContractsLayoutRoute =
  ReferrerLayoutContractsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ReferrerLayoutContractsRoute,
  } as any)
const ReferrerLayoutCommissionsLayoutRoute =
  ReferrerLayoutCommissionsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ReferrerLayoutCommissionsRoute,
  } as any)
const ReferrerLayoutAgentsLayoutRoute =
  ReferrerLayoutAgentsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ReferrerLayoutAgentsRoute,
  } as any)
const AdminLayoutTicketsLayoutRoute =
  AdminLayoutTicketsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AdminLayoutTicketsRoute,
  } as any)
const AdminLayoutTenantsLayoutRoute =
  AdminLayoutTenantsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AdminLayoutTenantsRoute,
  } as any)
const AdminLayoutSystemMonitorLayoutRoute =
  AdminLayoutSystemMonitorLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AdminLayoutSystemMonitorRoute,
  } as any)
const AdminLayoutServiceUsageByServiceRoute =
  AdminLayoutServiceUsageByServiceRouteImport.update({
    id: '/by-service',
    path: '/by-service',
    getParentRoute: () => AdminLayoutServiceUsageRoute,
  } as any)
const AdminLayoutServiceUsageLayoutRoute =
  AdminLayoutServiceUsageLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AdminLayoutServiceUsageRoute,
  } as any)
const AdminLayoutReferrersLayoutRoute =
  AdminLayoutReferrersLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AdminLayoutReferrersRoute,
  } as any)
const AdminLayoutNotificationsLayoutRoute =
  AdminLayoutNotificationsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AdminLayoutNotificationsRoute,
  } as any)
const AdminLayoutMcpClientsLayoutRoute =
  AdminLayoutMcpClientsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AdminLayoutMcpClientsRoute,
  } as any)
const AdminLayoutForeignVendorsLayoutRoute =
  AdminLayoutForeignVendorsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AdminLayoutForeignVendorsRoute,
  } as any)
const AdminLayoutErrorLogsLayoutRoute =
  AdminLayoutErrorLogsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AdminLayoutErrorLogsRoute,
  } as any)
const AdminLayoutContractsLayoutRoute =
  AdminLayoutContractsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AdminLayoutContractsRoute,
  } as any)
const AdminLayoutCommissionsLayoutRoute =
  AdminLayoutCommissionsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AdminLayoutCommissionsRoute,
  } as any)
const AdminLayoutAppointeeLayoutRoute =
  AdminLayoutAppointeeLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AdminLayoutAppointeeRoute,
  } as any)
const AdminLayoutAdvisorsLayoutRoute =
  AdminLayoutAdvisorsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AdminLayoutAdvisorsRoute,
  } as any)
const AdminLayoutAdminsLayoutRoute = AdminLayoutAdminsLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => AdminLayoutAdminsRoute,
} as any)
const AdminLayoutAcubePaymentsLayoutRoute =
  AdminLayoutAcubePaymentsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AdminLayoutAcubePaymentsRoute,
  } as any)
const AdminLayoutAcubeJobsLayoutRoute =
  AdminLayoutAcubeJobsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AdminLayoutAcubeJobsRoute,
  } as any)
const AdminLayoutSystemMonitorLayoutRunsRoute =
  AdminLayoutSystemMonitorLayoutRunsRouteImport.update({
    id: '/runs',
    path: '/runs',
    getParentRoute: () => AdminLayoutSystemMonitorLayoutRoute,
  } as any)
const ReferrerLayoutTenantsLayoutIndexRoute =
  ReferrerLayoutTenantsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ReferrerLayoutTenantsLayoutRoute,
  } as any)
const ReferrerLayoutContractsLayoutIndexRoute =
  ReferrerLayoutContractsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ReferrerLayoutContractsLayoutRoute,
  } as any)
const ReferrerLayoutCommissionsLayoutIndexRoute =
  ReferrerLayoutCommissionsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ReferrerLayoutCommissionsLayoutRoute,
  } as any)
const ReferrerLayoutAgentsLayoutIndexRoute =
  ReferrerLayoutAgentsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ReferrerLayoutAgentsLayoutRoute,
  } as any)
const AdminLayoutTicketsLayoutIndexRoute =
  AdminLayoutTicketsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutTicketsLayoutRoute,
  } as any)
const AdminLayoutTenantsLayoutIndexRoute =
  AdminLayoutTenantsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutTenantsLayoutRoute,
  } as any)
const AdminLayoutSystemMonitorLayoutIndexRoute =
  AdminLayoutSystemMonitorLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutSystemMonitorLayoutRoute,
  } as any)
const AdminLayoutServiceUsageLayoutIndexRoute =
  AdminLayoutServiceUsageLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutServiceUsageLayoutRoute,
  } as any)
const AdminLayoutReferrersLayoutIndexRoute =
  AdminLayoutReferrersLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutReferrersLayoutRoute,
  } as any)
const AdminLayoutNotificationsLayoutIndexRoute =
  AdminLayoutNotificationsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutNotificationsLayoutRoute,
  } as any)
const AdminLayoutMcpClientsLayoutIndexRoute =
  AdminLayoutMcpClientsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutMcpClientsLayoutRoute,
  } as any)
const AdminLayoutForeignVendorsLayoutIndexRoute =
  AdminLayoutForeignVendorsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutForeignVendorsLayoutRoute,
  } as any)
const AdminLayoutErrorLogsLayoutIndexRoute =
  AdminLayoutErrorLogsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutErrorLogsLayoutRoute,
  } as any)
const AdminLayoutContractsLayoutIndexRoute =
  AdminLayoutContractsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutContractsLayoutRoute,
  } as any)
const AdminLayoutCommissionsLayoutIndexRoute =
  AdminLayoutCommissionsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutCommissionsLayoutRoute,
  } as any)
const AdminLayoutAppointeeLayoutIndexRoute =
  AdminLayoutAppointeeLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutAppointeeLayoutRoute,
  } as any)
const AdminLayoutAdvisorsLayoutIndexRoute =
  AdminLayoutAdvisorsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutAdvisorsLayoutRoute,
  } as any)
const AdminLayoutAdminsLayoutIndexRoute =
  AdminLayoutAdminsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutAdminsLayoutRoute,
  } as any)
const AdminLayoutAcubePaymentsLayoutIndexRoute =
  AdminLayoutAcubePaymentsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutAcubePaymentsLayoutRoute,
  } as any)
const AdminLayoutAcubeJobsLayoutIndexRoute =
  AdminLayoutAcubeJobsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutAcubeJobsLayoutRoute,
  } as any)
const ReferrerLayoutTenantsLayoutIdRoute =
  ReferrerLayoutTenantsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ReferrerLayoutTenantsLayoutRoute,
  } as any)
const ReferrerLayoutContractsLayoutNewRoute =
  ReferrerLayoutContractsLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ReferrerLayoutContractsLayoutRoute,
  } as any)
const ReferrerLayoutContractsLayoutIdRoute =
  ReferrerLayoutContractsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ReferrerLayoutContractsLayoutRoute,
  } as any)
const ReferrerLayoutCommissionsLayoutIdRoute =
  ReferrerLayoutCommissionsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ReferrerLayoutCommissionsLayoutRoute,
  } as any)
const ReferrerLayoutAgentsLayoutNewRoute =
  ReferrerLayoutAgentsLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ReferrerLayoutAgentsLayoutRoute,
  } as any)
const ReferrerLayoutAgentsLayoutIdRoute =
  ReferrerLayoutAgentsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ReferrerLayoutAgentsLayoutRoute,
  } as any)
const AdminLayoutTicketsLayoutIdRoute =
  AdminLayoutTicketsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AdminLayoutTicketsLayoutRoute,
  } as any)
const AdminLayoutTenantsLayoutIdRoute =
  AdminLayoutTenantsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AdminLayoutTenantsLayoutRoute,
  } as any)
const AdminLayoutSystemMonitorLayoutRedisRoute =
  AdminLayoutSystemMonitorLayoutRedisRouteImport.update({
    id: '/redis',
    path: '/redis',
    getParentRoute: () => AdminLayoutSystemMonitorLayoutRoute,
  } as any)
const AdminLayoutSystemMonitorLayoutQueuesRoute =
  AdminLayoutSystemMonitorLayoutQueuesRouteImport.update({
    id: '/queues',
    path: '/queues',
    getParentRoute: () => AdminLayoutSystemMonitorLayoutRoute,
  } as any)
const AdminLayoutSystemMonitorLayoutOverviewRoute =
  AdminLayoutSystemMonitorLayoutOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AdminLayoutSystemMonitorLayoutRoute,
  } as any)
const AdminLayoutSystemMonitorLayoutMetricsRoute =
  AdminLayoutSystemMonitorLayoutMetricsRouteImport.update({
    id: '/metrics',
    path: '/metrics',
    getParentRoute: () => AdminLayoutSystemMonitorLayoutRoute,
  } as any)
const AdminLayoutServiceUsageLayoutTenantIdRoute =
  AdminLayoutServiceUsageLayoutTenantIdRouteImport.update({
    id: '/$tenantId',
    path: '/$tenantId',
    getParentRoute: () => AdminLayoutServiceUsageLayoutRoute,
  } as any)
const AdminLayoutReferrersLayoutNewPartnerRoute =
  AdminLayoutReferrersLayoutNewPartnerRouteImport.update({
    id: '/new-partner',
    path: '/new-partner',
    getParentRoute: () => AdminLayoutReferrersLayoutRoute,
  } as any)
const AdminLayoutReferrersLayoutNewRoute =
  AdminLayoutReferrersLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AdminLayoutReferrersLayoutRoute,
  } as any)
const AdminLayoutReferrersLayoutIdRoute =
  AdminLayoutReferrersLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AdminLayoutReferrersLayoutRoute,
  } as any)
const AdminLayoutNotificationsLayoutIdRoute =
  AdminLayoutNotificationsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AdminLayoutNotificationsLayoutRoute,
  } as any)
const AdminLayoutMcpClientsLayoutIdRoute =
  AdminLayoutMcpClientsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AdminLayoutMcpClientsLayoutRoute,
  } as any)
const AdminLayoutForeignVendorsLayoutNewRoute =
  AdminLayoutForeignVendorsLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AdminLayoutForeignVendorsLayoutRoute,
  } as any)
const AdminLayoutErrorLogsLayoutIdRoute =
  AdminLayoutErrorLogsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AdminLayoutErrorLogsLayoutRoute,
  } as any)
const AdminLayoutContractsLayoutNewRoute =
  AdminLayoutContractsLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AdminLayoutContractsLayoutRoute,
  } as any)
const AdminLayoutContractsLayoutIdRoute =
  AdminLayoutContractsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AdminLayoutContractsLayoutRoute,
  } as any)
const AdminLayoutCommissionsLayoutIdRoute =
  AdminLayoutCommissionsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AdminLayoutCommissionsLayoutRoute,
  } as any)
const AdminLayoutAppointeeLayoutCredentialsRoute =
  AdminLayoutAppointeeLayoutCredentialsRouteImport.update({
    id: '/credentials',
    path: '/credentials',
    getParentRoute: () => AdminLayoutAppointeeLayoutRoute,
  } as any)
const AdminLayoutAppointeeLayoutIdRoute =
  AdminLayoutAppointeeLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AdminLayoutAppointeeLayoutRoute,
  } as any)
const AdminLayoutAdvisorsLayoutNewRoute =
  AdminLayoutAdvisorsLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AdminLayoutAdvisorsLayoutRoute,
  } as any)
const AdminLayoutAdvisorsLayoutIdRoute =
  AdminLayoutAdvisorsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AdminLayoutAdvisorsLayoutRoute,
  } as any)
const AdminLayoutAdminsLayoutNewRoute =
  AdminLayoutAdminsLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AdminLayoutAdminsLayoutRoute,
  } as any)
const AdminLayoutAcubePaymentsLayoutIdRoute =
  AdminLayoutAcubePaymentsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AdminLayoutAcubePaymentsLayoutRoute,
  } as any)
const AdminLayoutAcubeJobsLayoutIdRoute =
  AdminLayoutAcubeJobsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AdminLayoutAcubeJobsLayoutRoute,
  } as any)
const ReferrerLayoutContractsLayoutIdEditRoute =
  ReferrerLayoutContractsLayoutIdEditRouteImport.update({
    id: '/$id_/edit',
    path: '/$id/edit',
    getParentRoute: () => ReferrerLayoutContractsLayoutRoute,
  } as any)
const AdminLayoutSystemMonitorLayoutRunsLayoutRoute =
  AdminLayoutSystemMonitorLayoutRunsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AdminLayoutSystemMonitorLayoutRunsRoute,
  } as any)
const AdminLayoutSystemMonitorLayoutJobJobIdRoute =
  AdminLayoutSystemMonitorLayoutJobJobIdRouteImport.update({
    id: '/job/$jobId',
    path: '/job/$jobId',
    getParentRoute: () => AdminLayoutSystemMonitorLayoutRoute,
  } as any)
const AdminLayoutSystemMonitorLayoutFlowFlowIdRoute =
  AdminLayoutSystemMonitorLayoutFlowFlowIdRouteImport.update({
    id: '/flow/$flowId',
    path: '/flow/$flowId',
    getParentRoute: () => AdminLayoutSystemMonitorLayoutRoute,
  } as any)
const AdminLayoutReferrersLayoutEditIdRoute =
  AdminLayoutReferrersLayoutEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => AdminLayoutReferrersLayoutRoute,
  } as any)
const AdminLayoutNotificationsLayoutEditIdRoute =
  AdminLayoutNotificationsLayoutEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => AdminLayoutNotificationsLayoutRoute,
  } as any)
const AdminLayoutForeignVendorsLayoutEditIdRoute =
  AdminLayoutForeignVendorsLayoutEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => AdminLayoutForeignVendorsLayoutRoute,
  } as any)
const AdminLayoutContractsLayoutIdEditRoute =
  AdminLayoutContractsLayoutIdEditRouteImport.update({
    id: '/$id_/edit',
    path: '/$id/edit',
    getParentRoute: () => AdminLayoutContractsLayoutRoute,
  } as any)
const AdminLayoutAdvisorsLayoutEditIdRoute =
  AdminLayoutAdvisorsLayoutEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => AdminLayoutAdvisorsLayoutRoute,
  } as any)
const AdminLayoutAdminsLayoutEditIdRoute =
  AdminLayoutAdminsLayoutEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => AdminLayoutAdminsLayoutRoute,
  } as any)
const AdminLayoutAcubePaymentsLayoutSepaIdRoute =
  AdminLayoutAcubePaymentsLayoutSepaIdRouteImport.update({
    id: '/sepa/$id',
    path: '/sepa/$id',
    getParentRoute: () => AdminLayoutAcubePaymentsLayoutRoute,
  } as any)
const AdminLayoutSystemMonitorLayoutRunsLayoutIndexRoute =
  AdminLayoutSystemMonitorLayoutRunsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutSystemMonitorLayoutRunsLayoutRoute,
  } as any)
const AdminLayoutSystemMonitorLayoutRunsLayoutIdRoute =
  AdminLayoutSystemMonitorLayoutRunsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AdminLayoutSystemMonitorLayoutRunsLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminLayoutRouteWithChildren
  '/referrer': typeof ReferrerLayoutRouteWithChildren
  '/accept-invitation': typeof AcceptInvitationRoute
  '/password-reset': typeof PasswordResetRoute
  '/releases': typeof ReleasesRoute
  '/sign-in': typeof SignInRoute
  '/admin/dashboard': typeof AdminLayoutDashboardRoute
  '/referrer/dashboard': typeof ReferrerLayoutDashboardRoute
  '/referrer/infrastructure-costs': typeof ReferrerLayoutInfrastructureCostsRoute
  '/referrer/releases': typeof ReferrerLayoutReleasesRoute
  '/admin/acube-jobs': typeof AdminLayoutAcubeJobsLayoutRouteWithChildren
  '/admin/acube-payments': typeof AdminLayoutAcubePaymentsLayoutRouteWithChildren
  '/admin/admins': typeof AdminLayoutAdminsLayoutRouteWithChildren
  '/admin/advisors': typeof AdminLayoutAdvisorsLayoutRouteWithChildren
  '/admin/appointee': typeof AdminLayoutAppointeeLayoutRouteWithChildren
  '/admin/commissions': typeof AdminLayoutCommissionsLayoutRouteWithChildren
  '/admin/contracts': typeof AdminLayoutContractsLayoutRouteWithChildren
  '/admin/error-logs': typeof AdminLayoutErrorLogsLayoutRouteWithChildren
  '/admin/foreign-vendors': typeof AdminLayoutForeignVendorsLayoutRouteWithChildren
  '/admin/mcp-clients': typeof AdminLayoutMcpClientsLayoutRouteWithChildren
  '/admin/notifications': typeof AdminLayoutNotificationsLayoutRouteWithChildren
  '/admin/referrers': typeof AdminLayoutReferrersLayoutRouteWithChildren
  '/admin/service-usage': typeof AdminLayoutServiceUsageLayoutRouteWithChildren
  '/admin/service-usage/by-service': typeof AdminLayoutServiceUsageByServiceRoute
  '/admin/system-monitor': typeof AdminLayoutSystemMonitorLayoutRouteWithChildren
  '/admin/tenants': typeof AdminLayoutTenantsLayoutRouteWithChildren
  '/admin/tickets': typeof AdminLayoutTicketsLayoutRouteWithChildren
  '/referrer/agents': typeof ReferrerLayoutAgentsLayoutRouteWithChildren
  '/referrer/commissions': typeof ReferrerLayoutCommissionsLayoutRouteWithChildren
  '/referrer/contracts': typeof ReferrerLayoutContractsLayoutRouteWithChildren
  '/referrer/tenants': typeof ReferrerLayoutTenantsLayoutRouteWithChildren
  '/admin/ai-usage': typeof AdminLayoutAiUsageIndexRoute
  '/admin/infrastructure-costs': typeof AdminLayoutInfrastructureCostsIndexRoute
  '/admin/releases': typeof AdminLayoutReleasesIndexRoute
  '/admin/acube-jobs/$id': typeof AdminLayoutAcubeJobsLayoutIdRoute
  '/admin/acube-payments/$id': typeof AdminLayoutAcubePaymentsLayoutIdRoute
  '/admin/admins/new': typeof AdminLayoutAdminsLayoutNewRoute
  '/admin/advisors/$id': typeof AdminLayoutAdvisorsLayoutIdRoute
  '/admin/advisors/new': typeof AdminLayoutAdvisorsLayoutNewRoute
  '/admin/appointee/$id': typeof AdminLayoutAppointeeLayoutIdRoute
  '/admin/appointee/credentials': typeof AdminLayoutAppointeeLayoutCredentialsRoute
  '/admin/commissions/$id': typeof AdminLayoutCommissionsLayoutIdRoute
  '/admin/contracts/$id': typeof AdminLayoutContractsLayoutIdRoute
  '/admin/contracts/new': typeof AdminLayoutContractsLayoutNewRoute
  '/admin/error-logs/$id': typeof AdminLayoutErrorLogsLayoutIdRoute
  '/admin/foreign-vendors/new': typeof AdminLayoutForeignVendorsLayoutNewRoute
  '/admin/mcp-clients/$id': typeof AdminLayoutMcpClientsLayoutIdRoute
  '/admin/notifications/$id': typeof AdminLayoutNotificationsLayoutIdRoute
  '/admin/referrers/$id': typeof AdminLayoutReferrersLayoutIdRoute
  '/admin/referrers/new': typeof AdminLayoutReferrersLayoutNewRoute
  '/admin/referrers/new-partner': typeof AdminLayoutReferrersLayoutNewPartnerRoute
  '/admin/service-usage/$tenantId': typeof AdminLayoutServiceUsageLayoutTenantIdRoute
  '/admin/system-monitor/metrics': typeof AdminLayoutSystemMonitorLayoutMetricsRoute
  '/admin/system-monitor/overview': typeof AdminLayoutSystemMonitorLayoutOverviewRoute
  '/admin/system-monitor/queues': typeof AdminLayoutSystemMonitorLayoutQueuesRoute
  '/admin/system-monitor/redis': typeof AdminLayoutSystemMonitorLayoutRedisRoute
  '/admin/tenants/$id': typeof AdminLayoutTenantsLayoutIdRoute
  '/admin/tickets/$id': typeof AdminLayoutTicketsLayoutIdRoute
  '/referrer/agents/$id': typeof ReferrerLayoutAgentsLayoutIdRoute
  '/referrer/agents/new': typeof ReferrerLayoutAgentsLayoutNewRoute
  '/referrer/commissions/$id': typeof ReferrerLayoutCommissionsLayoutIdRoute
  '/referrer/contracts/$id': typeof ReferrerLayoutContractsLayoutIdRoute
  '/referrer/contracts/new': typeof ReferrerLayoutContractsLayoutNewRoute
  '/referrer/tenants/$id': typeof ReferrerLayoutTenantsLayoutIdRoute
  '/admin/acube-jobs/': typeof AdminLayoutAcubeJobsLayoutIndexRoute
  '/admin/acube-payments/': typeof AdminLayoutAcubePaymentsLayoutIndexRoute
  '/admin/admins/': typeof AdminLayoutAdminsLayoutIndexRoute
  '/admin/advisors/': typeof AdminLayoutAdvisorsLayoutIndexRoute
  '/admin/appointee/': typeof AdminLayoutAppointeeLayoutIndexRoute
  '/admin/commissions/': typeof AdminLayoutCommissionsLayoutIndexRoute
  '/admin/contracts/': typeof AdminLayoutContractsLayoutIndexRoute
  '/admin/error-logs/': typeof AdminLayoutErrorLogsLayoutIndexRoute
  '/admin/foreign-vendors/': typeof AdminLayoutForeignVendorsLayoutIndexRoute
  '/admin/mcp-clients/': typeof AdminLayoutMcpClientsLayoutIndexRoute
  '/admin/notifications/': typeof AdminLayoutNotificationsLayoutIndexRoute
  '/admin/referrers/': typeof AdminLayoutReferrersLayoutIndexRoute
  '/admin/service-usage/': typeof AdminLayoutServiceUsageLayoutIndexRoute
  '/admin/system-monitor/': typeof AdminLayoutSystemMonitorLayoutIndexRoute
  '/admin/tenants/': typeof AdminLayoutTenantsLayoutIndexRoute
  '/admin/tickets/': typeof AdminLayoutTicketsLayoutIndexRoute
  '/referrer/agents/': typeof ReferrerLayoutAgentsLayoutIndexRoute
  '/referrer/commissions/': typeof ReferrerLayoutCommissionsLayoutIndexRoute
  '/referrer/contracts/': typeof ReferrerLayoutContractsLayoutIndexRoute
  '/referrer/tenants/': typeof ReferrerLayoutTenantsLayoutIndexRoute
  '/admin/acube-payments/sepa/$id': typeof AdminLayoutAcubePaymentsLayoutSepaIdRoute
  '/admin/admins/edit/$id': typeof AdminLayoutAdminsLayoutEditIdRoute
  '/admin/advisors/edit/$id': typeof AdminLayoutAdvisorsLayoutEditIdRoute
  '/admin/contracts/$id/edit': typeof AdminLayoutContractsLayoutIdEditRoute
  '/admin/foreign-vendors/edit/$id': typeof AdminLayoutForeignVendorsLayoutEditIdRoute
  '/admin/notifications/edit/$id': typeof AdminLayoutNotificationsLayoutEditIdRoute
  '/admin/referrers/edit/$id': typeof AdminLayoutReferrersLayoutEditIdRoute
  '/admin/system-monitor/flow/$flowId': typeof AdminLayoutSystemMonitorLayoutFlowFlowIdRoute
  '/admin/system-monitor/job/$jobId': typeof AdminLayoutSystemMonitorLayoutJobJobIdRoute
  '/admin/system-monitor/runs': typeof AdminLayoutSystemMonitorLayoutRunsLayoutRouteWithChildren
  '/referrer/contracts/$id/edit': typeof ReferrerLayoutContractsLayoutIdEditRoute
  '/admin/system-monitor/runs/$id': typeof AdminLayoutSystemMonitorLayoutRunsLayoutIdRoute
  '/admin/system-monitor/runs/': typeof AdminLayoutSystemMonitorLayoutRunsLayoutIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminLayoutRouteWithChildren
  '/referrer': typeof ReferrerLayoutRouteWithChildren
  '/accept-invitation': typeof AcceptInvitationRoute
  '/password-reset': typeof PasswordResetRoute
  '/releases': typeof ReleasesRoute
  '/sign-in': typeof SignInRoute
  '/admin/dashboard': typeof AdminLayoutDashboardRoute
  '/referrer/dashboard': typeof ReferrerLayoutDashboardRoute
  '/referrer/infrastructure-costs': typeof ReferrerLayoutInfrastructureCostsRoute
  '/referrer/releases': typeof ReferrerLayoutReleasesRoute
  '/admin/acube-jobs': typeof AdminLayoutAcubeJobsLayoutIndexRoute
  '/admin/acube-payments': typeof AdminLayoutAcubePaymentsLayoutIndexRoute
  '/admin/admins': typeof AdminLayoutAdminsLayoutIndexRoute
  '/admin/advisors': typeof AdminLayoutAdvisorsLayoutIndexRoute
  '/admin/appointee': typeof AdminLayoutAppointeeLayoutIndexRoute
  '/admin/commissions': typeof AdminLayoutCommissionsLayoutIndexRoute
  '/admin/contracts': typeof AdminLayoutContractsLayoutIndexRoute
  '/admin/error-logs': typeof AdminLayoutErrorLogsLayoutIndexRoute
  '/admin/foreign-vendors': typeof AdminLayoutForeignVendorsLayoutIndexRoute
  '/admin/mcp-clients': typeof AdminLayoutMcpClientsLayoutIndexRoute
  '/admin/notifications': typeof AdminLayoutNotificationsLayoutIndexRoute
  '/admin/referrers': typeof AdminLayoutReferrersLayoutIndexRoute
  '/admin/service-usage': typeof AdminLayoutServiceUsageLayoutIndexRoute
  '/admin/service-usage/by-service': typeof AdminLayoutServiceUsageByServiceRoute
  '/admin/system-monitor': typeof AdminLayoutSystemMonitorLayoutIndexRoute
  '/admin/tenants': typeof AdminLayoutTenantsLayoutIndexRoute
  '/admin/tickets': typeof AdminLayoutTicketsLayoutIndexRoute
  '/referrer/agents': typeof ReferrerLayoutAgentsLayoutIndexRoute
  '/referrer/commissions': typeof ReferrerLayoutCommissionsLayoutIndexRoute
  '/referrer/contracts': typeof ReferrerLayoutContractsLayoutIndexRoute
  '/referrer/tenants': typeof ReferrerLayoutTenantsLayoutIndexRoute
  '/admin/ai-usage': typeof AdminLayoutAiUsageIndexRoute
  '/admin/infrastructure-costs': typeof AdminLayoutInfrastructureCostsIndexRoute
  '/admin/releases': typeof AdminLayoutReleasesIndexRoute
  '/admin/acube-jobs/$id': typeof AdminLayoutAcubeJobsLayoutIdRoute
  '/admin/acube-payments/$id': typeof AdminLayoutAcubePaymentsLayoutIdRoute
  '/admin/admins/new': typeof AdminLayoutAdminsLayoutNewRoute
  '/admin/advisors/$id': typeof AdminLayoutAdvisorsLayoutIdRoute
  '/admin/advisors/new': typeof AdminLayoutAdvisorsLayoutNewRoute
  '/admin/appointee/$id': typeof AdminLayoutAppointeeLayoutIdRoute
  '/admin/appointee/credentials': typeof AdminLayoutAppointeeLayoutCredentialsRoute
  '/admin/commissions/$id': typeof AdminLayoutCommissionsLayoutIdRoute
  '/admin/contracts/$id': typeof AdminLayoutContractsLayoutIdRoute
  '/admin/contracts/new': typeof AdminLayoutContractsLayoutNewRoute
  '/admin/error-logs/$id': typeof AdminLayoutErrorLogsLayoutIdRoute
  '/admin/foreign-vendors/new': typeof AdminLayoutForeignVendorsLayoutNewRoute
  '/admin/mcp-clients/$id': typeof AdminLayoutMcpClientsLayoutIdRoute
  '/admin/notifications/$id': typeof AdminLayoutNotificationsLayoutIdRoute
  '/admin/referrers/$id': typeof AdminLayoutReferrersLayoutIdRoute
  '/admin/referrers/new': typeof AdminLayoutReferrersLayoutNewRoute
  '/admin/referrers/new-partner': typeof AdminLayoutReferrersLayoutNewPartnerRoute
  '/admin/service-usage/$tenantId': typeof AdminLayoutServiceUsageLayoutTenantIdRoute
  '/admin/system-monitor/metrics': typeof AdminLayoutSystemMonitorLayoutMetricsRoute
  '/admin/system-monitor/overview': typeof AdminLayoutSystemMonitorLayoutOverviewRoute
  '/admin/system-monitor/queues': typeof AdminLayoutSystemMonitorLayoutQueuesRoute
  '/admin/system-monitor/redis': typeof AdminLayoutSystemMonitorLayoutRedisRoute
  '/admin/tenants/$id': typeof AdminLayoutTenantsLayoutIdRoute
  '/admin/tickets/$id': typeof AdminLayoutTicketsLayoutIdRoute
  '/referrer/agents/$id': typeof ReferrerLayoutAgentsLayoutIdRoute
  '/referrer/agents/new': typeof ReferrerLayoutAgentsLayoutNewRoute
  '/referrer/commissions/$id': typeof ReferrerLayoutCommissionsLayoutIdRoute
  '/referrer/contracts/$id': typeof ReferrerLayoutContractsLayoutIdRoute
  '/referrer/contracts/new': typeof ReferrerLayoutContractsLayoutNewRoute
  '/referrer/tenants/$id': typeof ReferrerLayoutTenantsLayoutIdRoute
  '/admin/acube-payments/sepa/$id': typeof AdminLayoutAcubePaymentsLayoutSepaIdRoute
  '/admin/admins/edit/$id': typeof AdminLayoutAdminsLayoutEditIdRoute
  '/admin/advisors/edit/$id': typeof AdminLayoutAdvisorsLayoutEditIdRoute
  '/admin/contracts/$id/edit': typeof AdminLayoutContractsLayoutIdEditRoute
  '/admin/foreign-vendors/edit/$id': typeof AdminLayoutForeignVendorsLayoutEditIdRoute
  '/admin/notifications/edit/$id': typeof AdminLayoutNotificationsLayoutEditIdRoute
  '/admin/referrers/edit/$id': typeof AdminLayoutReferrersLayoutEditIdRoute
  '/admin/system-monitor/flow/$flowId': typeof AdminLayoutSystemMonitorLayoutFlowFlowIdRoute
  '/admin/system-monitor/job/$jobId': typeof AdminLayoutSystemMonitorLayoutJobJobIdRoute
  '/admin/system-monitor/runs': typeof AdminLayoutSystemMonitorLayoutRunsLayoutIndexRoute
  '/referrer/contracts/$id/edit': typeof ReferrerLayoutContractsLayoutIdEditRoute
  '/admin/system-monitor/runs/$id': typeof AdminLayoutSystemMonitorLayoutRunsLayoutIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/referrer': typeof ReferrerRouteRouteWithChildren
  '/accept-invitation': typeof AcceptInvitationRoute
  '/password-reset': typeof PasswordResetRoute
  '/releases': typeof ReleasesRoute
  '/sign-in': typeof SignInRoute
  '/admin/_layout': typeof AdminLayoutRouteWithChildren
  '/referrer/_layout': typeof ReferrerLayoutRouteWithChildren
  '/admin/_layout/dashboard': typeof AdminLayoutDashboardRoute
  '/referrer/_layout/dashboard': typeof ReferrerLayoutDashboardRoute
  '/referrer/_layout/infrastructure-costs': typeof ReferrerLayoutInfrastructureCostsRoute
  '/referrer/_layout/releases': typeof ReferrerLayoutReleasesRoute
  '/admin/_layout/acube-jobs': typeof AdminLayoutAcubeJobsRouteWithChildren
  '/admin/_layout/acube-jobs/_layout': typeof AdminLayoutAcubeJobsLayoutRouteWithChildren
  '/admin/_layout/acube-payments': typeof AdminLayoutAcubePaymentsRouteWithChildren
  '/admin/_layout/acube-payments/_layout': typeof AdminLayoutAcubePaymentsLayoutRouteWithChildren
  '/admin/_layout/admins': typeof AdminLayoutAdminsRouteWithChildren
  '/admin/_layout/admins/_layout': typeof AdminLayoutAdminsLayoutRouteWithChildren
  '/admin/_layout/advisors': typeof AdminLayoutAdvisorsRouteWithChildren
  '/admin/_layout/advisors/_layout': typeof AdminLayoutAdvisorsLayoutRouteWithChildren
  '/admin/_layout/appointee': typeof AdminLayoutAppointeeRouteWithChildren
  '/admin/_layout/appointee/_layout': typeof AdminLayoutAppointeeLayoutRouteWithChildren
  '/admin/_layout/commissions': typeof AdminLayoutCommissionsRouteWithChildren
  '/admin/_layout/commissions/_layout': typeof AdminLayoutCommissionsLayoutRouteWithChildren
  '/admin/_layout/contracts': typeof AdminLayoutContractsRouteWithChildren
  '/admin/_layout/contracts/_layout': typeof AdminLayoutContractsLayoutRouteWithChildren
  '/admin/_layout/error-logs': typeof AdminLayoutErrorLogsRouteWithChildren
  '/admin/_layout/error-logs/_layout': typeof AdminLayoutErrorLogsLayoutRouteWithChildren
  '/admin/_layout/foreign-vendors': typeof AdminLayoutForeignVendorsRouteWithChildren
  '/admin/_layout/foreign-vendors/_layout': typeof AdminLayoutForeignVendorsLayoutRouteWithChildren
  '/admin/_layout/mcp-clients': typeof AdminLayoutMcpClientsRouteWithChildren
  '/admin/_layout/mcp-clients/_layout': typeof AdminLayoutMcpClientsLayoutRouteWithChildren
  '/admin/_layout/notifications': typeof AdminLayoutNotificationsRouteWithChildren
  '/admin/_layout/notifications/_layout': typeof AdminLayoutNotificationsLayoutRouteWithChildren
  '/admin/_layout/referrers': typeof AdminLayoutReferrersRouteWithChildren
  '/admin/_layout/referrers/_layout': typeof AdminLayoutReferrersLayoutRouteWithChildren
  '/admin/_layout/service-usage': typeof AdminLayoutServiceUsageRouteWithChildren
  '/admin/_layout/service-usage/_layout': typeof AdminLayoutServiceUsageLayoutRouteWithChildren
  '/admin/_layout/service-usage/by-service': typeof AdminLayoutServiceUsageByServiceRoute
  '/admin/_layout/system-monitor': typeof AdminLayoutSystemMonitorRouteWithChildren
  '/admin/_layout/system-monitor/_layout': typeof AdminLayoutSystemMonitorLayoutRouteWithChildren
  '/admin/_layout/tenants': typeof AdminLayoutTenantsRouteWithChildren
  '/admin/_layout/tenants/_layout': typeof AdminLayoutTenantsLayoutRouteWithChildren
  '/admin/_layout/tickets': typeof AdminLayoutTicketsRouteWithChildren
  '/admin/_layout/tickets/_layout': typeof AdminLayoutTicketsLayoutRouteWithChildren
  '/referrer/_layout/agents': typeof ReferrerLayoutAgentsRouteWithChildren
  '/referrer/_layout/agents/_layout': typeof ReferrerLayoutAgentsLayoutRouteWithChildren
  '/referrer/_layout/commissions': typeof ReferrerLayoutCommissionsRouteWithChildren
  '/referrer/_layout/commissions/_layout': typeof ReferrerLayoutCommissionsLayoutRouteWithChildren
  '/referrer/_layout/contracts': typeof ReferrerLayoutContractsRouteWithChildren
  '/referrer/_layout/contracts/_layout': typeof ReferrerLayoutContractsLayoutRouteWithChildren
  '/referrer/_layout/tenants': typeof ReferrerLayoutTenantsRouteWithChildren
  '/referrer/_layout/tenants/_layout': typeof ReferrerLayoutTenantsLayoutRouteWithChildren
  '/admin/_layout/ai-usage/': typeof AdminLayoutAiUsageIndexRoute
  '/admin/_layout/infrastructure-costs/': typeof AdminLayoutInfrastructureCostsIndexRoute
  '/admin/_layout/releases/': typeof AdminLayoutReleasesIndexRoute
  '/admin/_layout/acube-jobs/_layout/$id': typeof AdminLayoutAcubeJobsLayoutIdRoute
  '/admin/_layout/acube-payments/_layout/$id': typeof AdminLayoutAcubePaymentsLayoutIdRoute
  '/admin/_layout/admins/_layout/new': typeof AdminLayoutAdminsLayoutNewRoute
  '/admin/_layout/advisors/_layout/$id': typeof AdminLayoutAdvisorsLayoutIdRoute
  '/admin/_layout/advisors/_layout/new': typeof AdminLayoutAdvisorsLayoutNewRoute
  '/admin/_layout/appointee/_layout/$id': typeof AdminLayoutAppointeeLayoutIdRoute
  '/admin/_layout/appointee/_layout/credentials': typeof AdminLayoutAppointeeLayoutCredentialsRoute
  '/admin/_layout/commissions/_layout/$id': typeof AdminLayoutCommissionsLayoutIdRoute
  '/admin/_layout/contracts/_layout/$id': typeof AdminLayoutContractsLayoutIdRoute
  '/admin/_layout/contracts/_layout/new': typeof AdminLayoutContractsLayoutNewRoute
  '/admin/_layout/error-logs/_layout/$id': typeof AdminLayoutErrorLogsLayoutIdRoute
  '/admin/_layout/foreign-vendors/_layout/new': typeof AdminLayoutForeignVendorsLayoutNewRoute
  '/admin/_layout/mcp-clients/_layout/$id': typeof AdminLayoutMcpClientsLayoutIdRoute
  '/admin/_layout/notifications/_layout/$id': typeof AdminLayoutNotificationsLayoutIdRoute
  '/admin/_layout/referrers/_layout/$id': typeof AdminLayoutReferrersLayoutIdRoute
  '/admin/_layout/referrers/_layout/new': typeof AdminLayoutReferrersLayoutNewRoute
  '/admin/_layout/referrers/_layout/new-partner': typeof AdminLayoutReferrersLayoutNewPartnerRoute
  '/admin/_layout/service-usage/_layout/$tenantId': typeof AdminLayoutServiceUsageLayoutTenantIdRoute
  '/admin/_layout/system-monitor/_layout/metrics': typeof AdminLayoutSystemMonitorLayoutMetricsRoute
  '/admin/_layout/system-monitor/_layout/overview': typeof AdminLayoutSystemMonitorLayoutOverviewRoute
  '/admin/_layout/system-monitor/_layout/queues': typeof AdminLayoutSystemMonitorLayoutQueuesRoute
  '/admin/_layout/system-monitor/_layout/redis': typeof AdminLayoutSystemMonitorLayoutRedisRoute
  '/admin/_layout/tenants/_layout/$id': typeof AdminLayoutTenantsLayoutIdRoute
  '/admin/_layout/tickets/_layout/$id': typeof AdminLayoutTicketsLayoutIdRoute
  '/referrer/_layout/agents/_layout/$id': typeof ReferrerLayoutAgentsLayoutIdRoute
  '/referrer/_layout/agents/_layout/new': typeof ReferrerLayoutAgentsLayoutNewRoute
  '/referrer/_layout/commissions/_layout/$id': typeof ReferrerLayoutCommissionsLayoutIdRoute
  '/referrer/_layout/contracts/_layout/$id': typeof ReferrerLayoutContractsLayoutIdRoute
  '/referrer/_layout/contracts/_layout/new': typeof ReferrerLayoutContractsLayoutNewRoute
  '/referrer/_layout/tenants/_layout/$id': typeof ReferrerLayoutTenantsLayoutIdRoute
  '/admin/_layout/acube-jobs/_layout/': typeof AdminLayoutAcubeJobsLayoutIndexRoute
  '/admin/_layout/acube-payments/_layout/': typeof AdminLayoutAcubePaymentsLayoutIndexRoute
  '/admin/_layout/admins/_layout/': typeof AdminLayoutAdminsLayoutIndexRoute
  '/admin/_layout/advisors/_layout/': typeof AdminLayoutAdvisorsLayoutIndexRoute
  '/admin/_layout/appointee/_layout/': typeof AdminLayoutAppointeeLayoutIndexRoute
  '/admin/_layout/commissions/_layout/': typeof AdminLayoutCommissionsLayoutIndexRoute
  '/admin/_layout/contracts/_layout/': typeof AdminLayoutContractsLayoutIndexRoute
  '/admin/_layout/error-logs/_layout/': typeof AdminLayoutErrorLogsLayoutIndexRoute
  '/admin/_layout/foreign-vendors/_layout/': typeof AdminLayoutForeignVendorsLayoutIndexRoute
  '/admin/_layout/mcp-clients/_layout/': typeof AdminLayoutMcpClientsLayoutIndexRoute
  '/admin/_layout/notifications/_layout/': typeof AdminLayoutNotificationsLayoutIndexRoute
  '/admin/_layout/referrers/_layout/': typeof AdminLayoutReferrersLayoutIndexRoute
  '/admin/_layout/service-usage/_layout/': typeof AdminLayoutServiceUsageLayoutIndexRoute
  '/admin/_layout/system-monitor/_layout/': typeof AdminLayoutSystemMonitorLayoutIndexRoute
  '/admin/_layout/tenants/_layout/': typeof AdminLayoutTenantsLayoutIndexRoute
  '/admin/_layout/tickets/_layout/': typeof AdminLayoutTicketsLayoutIndexRoute
  '/referrer/_layout/agents/_layout/': typeof ReferrerLayoutAgentsLayoutIndexRoute
  '/referrer/_layout/commissions/_layout/': typeof ReferrerLayoutCommissionsLayoutIndexRoute
  '/referrer/_layout/contracts/_layout/': typeof ReferrerLayoutContractsLayoutIndexRoute
  '/referrer/_layout/tenants/_layout/': typeof ReferrerLayoutTenantsLayoutIndexRoute
  '/admin/_layout/acube-payments/_layout/sepa/$id': typeof AdminLayoutAcubePaymentsLayoutSepaIdRoute
  '/admin/_layout/admins/_layout/edit/$id': typeof AdminLayoutAdminsLayoutEditIdRoute
  '/admin/_layout/advisors/_layout/edit/$id': typeof AdminLayoutAdvisorsLayoutEditIdRoute
  '/admin/_layout/contracts/_layout/$id_/edit': typeof AdminLayoutContractsLayoutIdEditRoute
  '/admin/_layout/foreign-vendors/_layout/edit/$id': typeof AdminLayoutForeignVendorsLayoutEditIdRoute
  '/admin/_layout/notifications/_layout/edit/$id': typeof AdminLayoutNotificationsLayoutEditIdRoute
  '/admin/_layout/referrers/_layout/edit/$id': typeof AdminLayoutReferrersLayoutEditIdRoute
  '/admin/_layout/system-monitor/_layout/flow/$flowId': typeof AdminLayoutSystemMonitorLayoutFlowFlowIdRoute
  '/admin/_layout/system-monitor/_layout/job/$jobId': typeof AdminLayoutSystemMonitorLayoutJobJobIdRoute
  '/admin/_layout/system-monitor/_layout/runs': typeof AdminLayoutSystemMonitorLayoutRunsRouteWithChildren
  '/admin/_layout/system-monitor/_layout/runs/_layout': typeof AdminLayoutSystemMonitorLayoutRunsLayoutRouteWithChildren
  '/referrer/_layout/contracts/_layout/$id_/edit': typeof ReferrerLayoutContractsLayoutIdEditRoute
  '/admin/_layout/system-monitor/_layout/runs/_layout/$id': typeof AdminLayoutSystemMonitorLayoutRunsLayoutIdRoute
  '/admin/_layout/system-monitor/_layout/runs/_layout/': typeof AdminLayoutSystemMonitorLayoutRunsLayoutIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/referrer'
    | '/accept-invitation'
    | '/password-reset'
    | '/releases'
    | '/sign-in'
    | '/admin/dashboard'
    | '/referrer/dashboard'
    | '/referrer/infrastructure-costs'
    | '/referrer/releases'
    | '/admin/acube-jobs'
    | '/admin/acube-payments'
    | '/admin/admins'
    | '/admin/advisors'
    | '/admin/appointee'
    | '/admin/commissions'
    | '/admin/contracts'
    | '/admin/error-logs'
    | '/admin/foreign-vendors'
    | '/admin/mcp-clients'
    | '/admin/notifications'
    | '/admin/referrers'
    | '/admin/service-usage'
    | '/admin/service-usage/by-service'
    | '/admin/system-monitor'
    | '/admin/tenants'
    | '/admin/tickets'
    | '/referrer/agents'
    | '/referrer/commissions'
    | '/referrer/contracts'
    | '/referrer/tenants'
    | '/admin/ai-usage'
    | '/admin/infrastructure-costs'
    | '/admin/releases'
    | '/admin/acube-jobs/$id'
    | '/admin/acube-payments/$id'
    | '/admin/admins/new'
    | '/admin/advisors/$id'
    | '/admin/advisors/new'
    | '/admin/appointee/$id'
    | '/admin/appointee/credentials'
    | '/admin/commissions/$id'
    | '/admin/contracts/$id'
    | '/admin/contracts/new'
    | '/admin/error-logs/$id'
    | '/admin/foreign-vendors/new'
    | '/admin/mcp-clients/$id'
    | '/admin/notifications/$id'
    | '/admin/referrers/$id'
    | '/admin/referrers/new'
    | '/admin/referrers/new-partner'
    | '/admin/service-usage/$tenantId'
    | '/admin/system-monitor/metrics'
    | '/admin/system-monitor/overview'
    | '/admin/system-monitor/queues'
    | '/admin/system-monitor/redis'
    | '/admin/tenants/$id'
    | '/admin/tickets/$id'
    | '/referrer/agents/$id'
    | '/referrer/agents/new'
    | '/referrer/commissions/$id'
    | '/referrer/contracts/$id'
    | '/referrer/contracts/new'
    | '/referrer/tenants/$id'
    | '/admin/acube-jobs/'
    | '/admin/acube-payments/'
    | '/admin/admins/'
    | '/admin/advisors/'
    | '/admin/appointee/'
    | '/admin/commissions/'
    | '/admin/contracts/'
    | '/admin/error-logs/'
    | '/admin/foreign-vendors/'
    | '/admin/mcp-clients/'
    | '/admin/notifications/'
    | '/admin/referrers/'
    | '/admin/service-usage/'
    | '/admin/system-monitor/'
    | '/admin/tenants/'
    | '/admin/tickets/'
    | '/referrer/agents/'
    | '/referrer/commissions/'
    | '/referrer/contracts/'
    | '/referrer/tenants/'
    | '/admin/acube-payments/sepa/$id'
    | '/admin/admins/edit/$id'
    | '/admin/advisors/edit/$id'
    | '/admin/contracts/$id/edit'
    | '/admin/foreign-vendors/edit/$id'
    | '/admin/notifications/edit/$id'
    | '/admin/referrers/edit/$id'
    | '/admin/system-monitor/flow/$flowId'
    | '/admin/system-monitor/job/$jobId'
    | '/admin/system-monitor/runs'
    | '/referrer/contracts/$id/edit'
    | '/admin/system-monitor/runs/$id'
    | '/admin/system-monitor/runs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/referrer'
    | '/accept-invitation'
    | '/password-reset'
    | '/releases'
    | '/sign-in'
    | '/admin/dashboard'
    | '/referrer/dashboard'
    | '/referrer/infrastructure-costs'
    | '/referrer/releases'
    | '/admin/acube-jobs'
    | '/admin/acube-payments'
    | '/admin/admins'
    | '/admin/advisors'
    | '/admin/appointee'
    | '/admin/commissions'
    | '/admin/contracts'
    | '/admin/error-logs'
    | '/admin/foreign-vendors'
    | '/admin/mcp-clients'
    | '/admin/notifications'
    | '/admin/referrers'
    | '/admin/service-usage'
    | '/admin/service-usage/by-service'
    | '/admin/system-monitor'
    | '/admin/tenants'
    | '/admin/tickets'
    | '/referrer/agents'
    | '/referrer/commissions'
    | '/referrer/contracts'
    | '/referrer/tenants'
    | '/admin/ai-usage'
    | '/admin/infrastructure-costs'
    | '/admin/releases'
    | '/admin/acube-jobs/$id'
    | '/admin/acube-payments/$id'
    | '/admin/admins/new'
    | '/admin/advisors/$id'
    | '/admin/advisors/new'
    | '/admin/appointee/$id'
    | '/admin/appointee/credentials'
    | '/admin/commissions/$id'
    | '/admin/contracts/$id'
    | '/admin/contracts/new'
    | '/admin/error-logs/$id'
    | '/admin/foreign-vendors/new'
    | '/admin/mcp-clients/$id'
    | '/admin/notifications/$id'
    | '/admin/referrers/$id'
    | '/admin/referrers/new'
    | '/admin/referrers/new-partner'
    | '/admin/service-usage/$tenantId'
    | '/admin/system-monitor/metrics'
    | '/admin/system-monitor/overview'
    | '/admin/system-monitor/queues'
    | '/admin/system-monitor/redis'
    | '/admin/tenants/$id'
    | '/admin/tickets/$id'
    | '/referrer/agents/$id'
    | '/referrer/agents/new'
    | '/referrer/commissions/$id'
    | '/referrer/contracts/$id'
    | '/referrer/contracts/new'
    | '/referrer/tenants/$id'
    | '/admin/acube-payments/sepa/$id'
    | '/admin/admins/edit/$id'
    | '/admin/advisors/edit/$id'
    | '/admin/contracts/$id/edit'
    | '/admin/foreign-vendors/edit/$id'
    | '/admin/notifications/edit/$id'
    | '/admin/referrers/edit/$id'
    | '/admin/system-monitor/flow/$flowId'
    | '/admin/system-monitor/job/$jobId'
    | '/admin/system-monitor/runs'
    | '/referrer/contracts/$id/edit'
    | '/admin/system-monitor/runs/$id'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/referrer'
    | '/accept-invitation'
    | '/password-reset'
    | '/releases'
    | '/sign-in'
    | '/admin/_layout'
    | '/referrer/_layout'
    | '/admin/_layout/dashboard'
    | '/referrer/_layout/dashboard'
    | '/referrer/_layout/infrastructure-costs'
    | '/referrer/_layout/releases'
    | '/admin/_layout/acube-jobs'
    | '/admin/_layout/acube-jobs/_layout'
    | '/admin/_layout/acube-payments'
    | '/admin/_layout/acube-payments/_layout'
    | '/admin/_layout/admins'
    | '/admin/_layout/admins/_layout'
    | '/admin/_layout/advisors'
    | '/admin/_layout/advisors/_layout'
    | '/admin/_layout/appointee'
    | '/admin/_layout/appointee/_layout'
    | '/admin/_layout/commissions'
    | '/admin/_layout/commissions/_layout'
    | '/admin/_layout/contracts'
    | '/admin/_layout/contracts/_layout'
    | '/admin/_layout/error-logs'
    | '/admin/_layout/error-logs/_layout'
    | '/admin/_layout/foreign-vendors'
    | '/admin/_layout/foreign-vendors/_layout'
    | '/admin/_layout/mcp-clients'
    | '/admin/_layout/mcp-clients/_layout'
    | '/admin/_layout/notifications'
    | '/admin/_layout/notifications/_layout'
    | '/admin/_layout/referrers'
    | '/admin/_layout/referrers/_layout'
    | '/admin/_layout/service-usage'
    | '/admin/_layout/service-usage/_layout'
    | '/admin/_layout/service-usage/by-service'
    | '/admin/_layout/system-monitor'
    | '/admin/_layout/system-monitor/_layout'
    | '/admin/_layout/tenants'
    | '/admin/_layout/tenants/_layout'
    | '/admin/_layout/tickets'
    | '/admin/_layout/tickets/_layout'
    | '/referrer/_layout/agents'
    | '/referrer/_layout/agents/_layout'
    | '/referrer/_layout/commissions'
    | '/referrer/_layout/commissions/_layout'
    | '/referrer/_layout/contracts'
    | '/referrer/_layout/contracts/_layout'
    | '/referrer/_layout/tenants'
    | '/referrer/_layout/tenants/_layout'
    | '/admin/_layout/ai-usage/'
    | '/admin/_layout/infrastructure-costs/'
    | '/admin/_layout/releases/'
    | '/admin/_layout/acube-jobs/_layout/$id'
    | '/admin/_layout/acube-payments/_layout/$id'
    | '/admin/_layout/admins/_layout/new'
    | '/admin/_layout/advisors/_layout/$id'
    | '/admin/_layout/advisors/_layout/new'
    | '/admin/_layout/appointee/_layout/$id'
    | '/admin/_layout/appointee/_layout/credentials'
    | '/admin/_layout/commissions/_layout/$id'
    | '/admin/_layout/contracts/_layout/$id'
    | '/admin/_layout/contracts/_layout/new'
    | '/admin/_layout/error-logs/_layout/$id'
    | '/admin/_layout/foreign-vendors/_layout/new'
    | '/admin/_layout/mcp-clients/_layout/$id'
    | '/admin/_layout/notifications/_layout/$id'
    | '/admin/_layout/referrers/_layout/$id'
    | '/admin/_layout/referrers/_layout/new'
    | '/admin/_layout/referrers/_layout/new-partner'
    | '/admin/_layout/service-usage/_layout/$tenantId'
    | '/admin/_layout/system-monitor/_layout/metrics'
    | '/admin/_layout/system-monitor/_layout/overview'
    | '/admin/_layout/system-monitor/_layout/queues'
    | '/admin/_layout/system-monitor/_layout/redis'
    | '/admin/_layout/tenants/_layout/$id'
    | '/admin/_layout/tickets/_layout/$id'
    | '/referrer/_layout/agents/_layout/$id'
    | '/referrer/_layout/agents/_layout/new'
    | '/referrer/_layout/commissions/_layout/$id'
    | '/referrer/_layout/contracts/_layout/$id'
    | '/referrer/_layout/contracts/_layout/new'
    | '/referrer/_layout/tenants/_layout/$id'
    | '/admin/_layout/acube-jobs/_layout/'
    | '/admin/_layout/acube-payments/_layout/'
    | '/admin/_layout/admins/_layout/'
    | '/admin/_layout/advisors/_layout/'
    | '/admin/_layout/appointee/_layout/'
    | '/admin/_layout/commissions/_layout/'
    | '/admin/_layout/contracts/_layout/'
    | '/admin/_layout/error-logs/_layout/'
    | '/admin/_layout/foreign-vendors/_layout/'
    | '/admin/_layout/mcp-clients/_layout/'
    | '/admin/_layout/notifications/_layout/'
    | '/admin/_layout/referrers/_layout/'
    | '/admin/_layout/service-usage/_layout/'
    | '/admin/_layout/system-monitor/_layout/'
    | '/admin/_layout/tenants/_layout/'
    | '/admin/_layout/tickets/_layout/'
    | '/referrer/_layout/agents/_layout/'
    | '/referrer/_layout/commissions/_layout/'
    | '/referrer/_layout/contracts/_layout/'
    | '/referrer/_layout/tenants/_layout/'
    | '/admin/_layout/acube-payments/_layout/sepa/$id'
    | '/admin/_layout/admins/_layout/edit/$id'
    | '/admin/_layout/advisors/_layout/edit/$id'
    | '/admin/_layout/contracts/_layout/$id_/edit'
    | '/admin/_layout/foreign-vendors/_layout/edit/$id'
    | '/admin/_layout/notifications/_layout/edit/$id'
    | '/admin/_layout/referrers/_layout/edit/$id'
    | '/admin/_layout/system-monitor/_layout/flow/$flowId'
    | '/admin/_layout/system-monitor/_layout/job/$jobId'
    | '/admin/_layout/system-monitor/_layout/runs'
    | '/admin/_layout/system-monitor/_layout/runs/_layout'
    | '/referrer/_layout/contracts/_layout/$id_/edit'
    | '/admin/_layout/system-monitor/_layout/runs/_layout/$id'
    | '/admin/_layout/system-monitor/_layout/runs/_layout/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  ReferrerRouteRoute: typeof ReferrerRouteRouteWithChildren
  AcceptInvitationRoute: typeof AcceptInvitationRoute
  PasswordResetRoute: typeof PasswordResetRoute
  ReleasesRoute: typeof ReleasesRoute
  SignInRoute: typeof SignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/releases': {
      id: '/releases'
      path: '/releases'
      fullPath: '/releases'
      preLoaderRoute: typeof ReleasesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password-reset': {
      id: '/password-reset'
      path: '/password-reset'
      fullPath: '/password-reset'
      preLoaderRoute: typeof PasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation': {
      id: '/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AcceptInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/referrer': {
      id: '/referrer'
      path: '/referrer'
      fullPath: '/referrer'
      preLoaderRoute: typeof ReferrerRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/referrer/_layout': {
      id: '/referrer/_layout'
      path: ''
      fullPath: '/referrer'
      preLoaderRoute: typeof ReferrerLayoutRouteImport
      parentRoute: typeof ReferrerRouteRoute
    }
    '/admin/_layout': {
      id: '/admin/_layout'
      path: ''
      fullPath: '/admin'
      preLoaderRoute: typeof AdminLayoutRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/referrer/_layout/tenants': {
      id: '/referrer/_layout/tenants'
      path: '/tenants'
      fullPath: '/referrer/tenants'
      preLoaderRoute: typeof ReferrerLayoutTenantsRouteImport
      parentRoute: typeof ReferrerLayoutRoute
    }
    '/referrer/_layout/contracts': {
      id: '/referrer/_layout/contracts'
      path: '/contracts'
      fullPath: '/referrer/contracts'
      preLoaderRoute: typeof ReferrerLayoutContractsRouteImport
      parentRoute: typeof ReferrerLayoutRoute
    }
    '/referrer/_layout/commissions': {
      id: '/referrer/_layout/commissions'
      path: '/commissions'
      fullPath: '/referrer/commissions'
      preLoaderRoute: typeof ReferrerLayoutCommissionsRouteImport
      parentRoute: typeof ReferrerLayoutRoute
    }
    '/referrer/_layout/agents': {
      id: '/referrer/_layout/agents'
      path: '/agents'
      fullPath: '/referrer/agents'
      preLoaderRoute: typeof ReferrerLayoutAgentsRouteImport
      parentRoute: typeof ReferrerLayoutRoute
    }
    '/admin/_layout/tickets': {
      id: '/admin/_layout/tickets'
      path: '/tickets'
      fullPath: '/admin/tickets'
      preLoaderRoute: typeof AdminLayoutTicketsRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/tenants': {
      id: '/admin/_layout/tenants'
      path: '/tenants'
      fullPath: '/admin/tenants'
      preLoaderRoute: typeof AdminLayoutTenantsRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/system-monitor': {
      id: '/admin/_layout/system-monitor'
      path: '/system-monitor'
      fullPath: '/admin/system-monitor'
      preLoaderRoute: typeof AdminLayoutSystemMonitorRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/service-usage': {
      id: '/admin/_layout/service-usage'
      path: '/service-usage'
      fullPath: '/admin/service-usage'
      preLoaderRoute: typeof AdminLayoutServiceUsageRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/referrers': {
      id: '/admin/_layout/referrers'
      path: '/referrers'
      fullPath: '/admin/referrers'
      preLoaderRoute: typeof AdminLayoutReferrersRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/notifications': {
      id: '/admin/_layout/notifications'
      path: '/notifications'
      fullPath: '/admin/notifications'
      preLoaderRoute: typeof AdminLayoutNotificationsRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/mcp-clients': {
      id: '/admin/_layout/mcp-clients'
      path: '/mcp-clients'
      fullPath: '/admin/mcp-clients'
      preLoaderRoute: typeof AdminLayoutMcpClientsRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/foreign-vendors': {
      id: '/admin/_layout/foreign-vendors'
      path: '/foreign-vendors'
      fullPath: '/admin/foreign-vendors'
      preLoaderRoute: typeof AdminLayoutForeignVendorsRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/error-logs': {
      id: '/admin/_layout/error-logs'
      path: '/error-logs'
      fullPath: '/admin/error-logs'
      preLoaderRoute: typeof AdminLayoutErrorLogsRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/contracts': {
      id: '/admin/_layout/contracts'
      path: '/contracts'
      fullPath: '/admin/contracts'
      preLoaderRoute: typeof AdminLayoutContractsRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/commissions': {
      id: '/admin/_layout/commissions'
      path: '/commissions'
      fullPath: '/admin/commissions'
      preLoaderRoute: typeof AdminLayoutCommissionsRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/appointee': {
      id: '/admin/_layout/appointee'
      path: '/appointee'
      fullPath: '/admin/appointee'
      preLoaderRoute: typeof AdminLayoutAppointeeRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/advisors': {
      id: '/admin/_layout/advisors'
      path: '/advisors'
      fullPath: '/admin/advisors'
      preLoaderRoute: typeof AdminLayoutAdvisorsRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/admins': {
      id: '/admin/_layout/admins'
      path: '/admins'
      fullPath: '/admin/admins'
      preLoaderRoute: typeof AdminLayoutAdminsRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/acube-payments': {
      id: '/admin/_layout/acube-payments'
      path: '/acube-payments'
      fullPath: '/admin/acube-payments'
      preLoaderRoute: typeof AdminLayoutAcubePaymentsRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/acube-jobs': {
      id: '/admin/_layout/acube-jobs'
      path: '/acube-jobs'
      fullPath: '/admin/acube-jobs'
      preLoaderRoute: typeof AdminLayoutAcubeJobsRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/referrer/_layout/releases': {
      id: '/referrer/_layout/releases'
      path: '/releases'
      fullPath: '/referrer/releases'
      preLoaderRoute: typeof ReferrerLayoutReleasesRouteImport
      parentRoute: typeof ReferrerLayoutRoute
    }
    '/referrer/_layout/infrastructure-costs': {
      id: '/referrer/_layout/infrastructure-costs'
      path: '/infrastructure-costs'
      fullPath: '/referrer/infrastructure-costs'
      preLoaderRoute: typeof ReferrerLayoutInfrastructureCostsRouteImport
      parentRoute: typeof ReferrerLayoutRoute
    }
    '/referrer/_layout/dashboard': {
      id: '/referrer/_layout/dashboard'
      path: '/dashboard'
      fullPath: '/referrer/dashboard'
      preLoaderRoute: typeof ReferrerLayoutDashboardRouteImport
      parentRoute: typeof ReferrerLayoutRoute
    }
    '/admin/_layout/dashboard': {
      id: '/admin/_layout/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminLayoutDashboardRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/releases/': {
      id: '/admin/_layout/releases/'
      path: '/releases'
      fullPath: '/admin/releases'
      preLoaderRoute: typeof AdminLayoutReleasesIndexRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/infrastructure-costs/': {
      id: '/admin/_layout/infrastructure-costs/'
      path: '/infrastructure-costs'
      fullPath: '/admin/infrastructure-costs'
      preLoaderRoute: typeof AdminLayoutInfrastructureCostsIndexRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/ai-usage/': {
      id: '/admin/_layout/ai-usage/'
      path: '/ai-usage'
      fullPath: '/admin/ai-usage'
      preLoaderRoute: typeof AdminLayoutAiUsageIndexRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/referrer/_layout/tenants/_layout': {
      id: '/referrer/_layout/tenants/_layout'
      path: '/tenants'
      fullPath: '/referrer/tenants'
      preLoaderRoute: typeof ReferrerLayoutTenantsLayoutRouteImport
      parentRoute: typeof ReferrerLayoutTenantsRoute
    }
    '/referrer/_layout/contracts/_layout': {
      id: '/referrer/_layout/contracts/_layout'
      path: '/contracts'
      fullPath: '/referrer/contracts'
      preLoaderRoute: typeof ReferrerLayoutContractsLayoutRouteImport
      parentRoute: typeof ReferrerLayoutContractsRoute
    }
    '/referrer/_layout/commissions/_layout': {
      id: '/referrer/_layout/commissions/_layout'
      path: '/commissions'
      fullPath: '/referrer/commissions'
      preLoaderRoute: typeof ReferrerLayoutCommissionsLayoutRouteImport
      parentRoute: typeof ReferrerLayoutCommissionsRoute
    }
    '/referrer/_layout/agents/_layout': {
      id: '/referrer/_layout/agents/_layout'
      path: '/agents'
      fullPath: '/referrer/agents'
      preLoaderRoute: typeof ReferrerLayoutAgentsLayoutRouteImport
      parentRoute: typeof ReferrerLayoutAgentsRoute
    }
    '/admin/_layout/tickets/_layout': {
      id: '/admin/_layout/tickets/_layout'
      path: '/tickets'
      fullPath: '/admin/tickets'
      preLoaderRoute: typeof AdminLayoutTicketsLayoutRouteImport
      parentRoute: typeof AdminLayoutTicketsRoute
    }
    '/admin/_layout/tenants/_layout': {
      id: '/admin/_layout/tenants/_layout'
      path: '/tenants'
      fullPath: '/admin/tenants'
      preLoaderRoute: typeof AdminLayoutTenantsLayoutRouteImport
      parentRoute: typeof AdminLayoutTenantsRoute
    }
    '/admin/_layout/system-monitor/_layout': {
      id: '/admin/_layout/system-monitor/_layout'
      path: '/system-monitor'
      fullPath: '/admin/system-monitor'
      preLoaderRoute: typeof AdminLayoutSystemMonitorLayoutRouteImport
      parentRoute: typeof AdminLayoutSystemMonitorRoute
    }
    '/admin/_layout/service-usage/by-service': {
      id: '/admin/_layout/service-usage/by-service'
      path: '/by-service'
      fullPath: '/admin/service-usage/by-service'
      preLoaderRoute: typeof AdminLayoutServiceUsageByServiceRouteImport
      parentRoute: typeof AdminLayoutServiceUsageRoute
    }
    '/admin/_layout/service-usage/_layout': {
      id: '/admin/_layout/service-usage/_layout'
      path: '/service-usage'
      fullPath: '/admin/service-usage'
      preLoaderRoute: typeof AdminLayoutServiceUsageLayoutRouteImport
      parentRoute: typeof AdminLayoutServiceUsageRoute
    }
    '/admin/_layout/referrers/_layout': {
      id: '/admin/_layout/referrers/_layout'
      path: '/referrers'
      fullPath: '/admin/referrers'
      preLoaderRoute: typeof AdminLayoutReferrersLayoutRouteImport
      parentRoute: typeof AdminLayoutReferrersRoute
    }
    '/admin/_layout/notifications/_layout': {
      id: '/admin/_layout/notifications/_layout'
      path: '/notifications'
      fullPath: '/admin/notifications'
      preLoaderRoute: typeof AdminLayoutNotificationsLayoutRouteImport
      parentRoute: typeof AdminLayoutNotificationsRoute
    }
    '/admin/_layout/mcp-clients/_layout': {
      id: '/admin/_layout/mcp-clients/_layout'
      path: '/mcp-clients'
      fullPath: '/admin/mcp-clients'
      preLoaderRoute: typeof AdminLayoutMcpClientsLayoutRouteImport
      parentRoute: typeof AdminLayoutMcpClientsRoute
    }
    '/admin/_layout/foreign-vendors/_layout': {
      id: '/admin/_layout/foreign-vendors/_layout'
      path: '/foreign-vendors'
      fullPath: '/admin/foreign-vendors'
      preLoaderRoute: typeof AdminLayoutForeignVendorsLayoutRouteImport
      parentRoute: typeof AdminLayoutForeignVendorsRoute
    }
    '/admin/_layout/error-logs/_layout': {
      id: '/admin/_layout/error-logs/_layout'
      path: '/error-logs'
      fullPath: '/admin/error-logs'
      preLoaderRoute: typeof AdminLayoutErrorLogsLayoutRouteImport
      parentRoute: typeof AdminLayoutErrorLogsRoute
    }
    '/admin/_layout/contracts/_layout': {
      id: '/admin/_layout/contracts/_layout'
      path: '/contracts'
      fullPath: '/admin/contracts'
      preLoaderRoute: typeof AdminLayoutContractsLayoutRouteImport
      parentRoute: typeof AdminLayoutContractsRoute
    }
    '/admin/_layout/commissions/_layout': {
      id: '/admin/_layout/commissions/_layout'
      path: '/commissions'
      fullPath: '/admin/commissions'
      preLoaderRoute: typeof AdminLayoutCommissionsLayoutRouteImport
      parentRoute: typeof AdminLayoutCommissionsRoute
    }
    '/admin/_layout/appointee/_layout': {
      id: '/admin/_layout/appointee/_layout'
      path: '/appointee'
      fullPath: '/admin/appointee'
      preLoaderRoute: typeof AdminLayoutAppointeeLayoutRouteImport
      parentRoute: typeof AdminLayoutAppointeeRoute
    }
    '/admin/_layout/advisors/_layout': {
      id: '/admin/_layout/advisors/_layout'
      path: '/advisors'
      fullPath: '/admin/advisors'
      preLoaderRoute: typeof AdminLayoutAdvisorsLayoutRouteImport
      parentRoute: typeof AdminLayoutAdvisorsRoute
    }
    '/admin/_layout/admins/_layout': {
      id: '/admin/_layout/admins/_layout'
      path: '/admins'
      fullPath: '/admin/admins'
      preLoaderRoute: typeof AdminLayoutAdminsLayoutRouteImport
      parentRoute: typeof AdminLayoutAdminsRoute
    }
    '/admin/_layout/acube-payments/_layout': {
      id: '/admin/_layout/acube-payments/_layout'
      path: '/acube-payments'
      fullPath: '/admin/acube-payments'
      preLoaderRoute: typeof AdminLayoutAcubePaymentsLayoutRouteImport
      parentRoute: typeof AdminLayoutAcubePaymentsRoute
    }
    '/admin/_layout/acube-jobs/_layout': {
      id: '/admin/_layout/acube-jobs/_layout'
      path: '/acube-jobs'
      fullPath: '/admin/acube-jobs'
      preLoaderRoute: typeof AdminLayoutAcubeJobsLayoutRouteImport
      parentRoute: typeof AdminLayoutAcubeJobsRoute
    }
    '/admin/_layout/system-monitor/_layout/runs': {
      id: '/admin/_layout/system-monitor/_layout/runs'
      path: '/runs'
      fullPath: '/admin/system-monitor/runs'
      preLoaderRoute: typeof AdminLayoutSystemMonitorLayoutRunsRouteImport
      parentRoute: typeof AdminLayoutSystemMonitorLayoutRoute
    }
    '/referrer/_layout/tenants/_layout/': {
      id: '/referrer/_layout/tenants/_layout/'
      path: '/'
      fullPath: '/referrer/tenants/'
      preLoaderRoute: typeof ReferrerLayoutTenantsLayoutIndexRouteImport
      parentRoute: typeof ReferrerLayoutTenantsLayoutRoute
    }
    '/referrer/_layout/contracts/_layout/': {
      id: '/referrer/_layout/contracts/_layout/'
      path: '/'
      fullPath: '/referrer/contracts/'
      preLoaderRoute: typeof ReferrerLayoutContractsLayoutIndexRouteImport
      parentRoute: typeof ReferrerLayoutContractsLayoutRoute
    }
    '/referrer/_layout/commissions/_layout/': {
      id: '/referrer/_layout/commissions/_layout/'
      path: '/'
      fullPath: '/referrer/commissions/'
      preLoaderRoute: typeof ReferrerLayoutCommissionsLayoutIndexRouteImport
      parentRoute: typeof ReferrerLayoutCommissionsLayoutRoute
    }
    '/referrer/_layout/agents/_layout/': {
      id: '/referrer/_layout/agents/_layout/'
      path: '/'
      fullPath: '/referrer/agents/'
      preLoaderRoute: typeof ReferrerLayoutAgentsLayoutIndexRouteImport
      parentRoute: typeof ReferrerLayoutAgentsLayoutRoute
    }
    '/admin/_layout/tickets/_layout/': {
      id: '/admin/_layout/tickets/_layout/'
      path: '/'
      fullPath: '/admin/tickets/'
      preLoaderRoute: typeof AdminLayoutTicketsLayoutIndexRouteImport
      parentRoute: typeof AdminLayoutTicketsLayoutRoute
    }
    '/admin/_layout/tenants/_layout/': {
      id: '/admin/_layout/tenants/_layout/'
      path: '/'
      fullPath: '/admin/tenants/'
      preLoaderRoute: typeof AdminLayoutTenantsLayoutIndexRouteImport
      parentRoute: typeof AdminLayoutTenantsLayoutRoute
    }
    '/admin/_layout/system-monitor/_layout/': {
      id: '/admin/_layout/system-monitor/_layout/'
      path: '/'
      fullPath: '/admin/system-monitor/'
      preLoaderRoute: typeof AdminLayoutSystemMonitorLayoutIndexRouteImport
      parentRoute: typeof AdminLayoutSystemMonitorLayoutRoute
    }
    '/admin/_layout/service-usage/_layout/': {
      id: '/admin/_layout/service-usage/_layout/'
      path: '/'
      fullPath: '/admin/service-usage/'
      preLoaderRoute: typeof AdminLayoutServiceUsageLayoutIndexRouteImport
      parentRoute: typeof AdminLayoutServiceUsageLayoutRoute
    }
    '/admin/_layout/referrers/_layout/': {
      id: '/admin/_layout/referrers/_layout/'
      path: '/'
      fullPath: '/admin/referrers/'
      preLoaderRoute: typeof AdminLayoutReferrersLayoutIndexRouteImport
      parentRoute: typeof AdminLayoutReferrersLayoutRoute
    }
    '/admin/_layout/notifications/_layout/': {
      id: '/admin/_layout/notifications/_layout/'
      path: '/'
      fullPath: '/admin/notifications/'
      preLoaderRoute: typeof AdminLayoutNotificationsLayoutIndexRouteImport
      parentRoute: typeof AdminLayoutNotificationsLayoutRoute
    }
    '/admin/_layout/mcp-clients/_layout/': {
      id: '/admin/_layout/mcp-clients/_layout/'
      path: '/'
      fullPath: '/admin/mcp-clients/'
      preLoaderRoute: typeof AdminLayoutMcpClientsLayoutIndexRouteImport
      parentRoute: typeof AdminLayoutMcpClientsLayoutRoute
    }
    '/admin/_layout/foreign-vendors/_layout/': {
      id: '/admin/_layout/foreign-vendors/_layout/'
      path: '/'
      fullPath: '/admin/foreign-vendors/'
      preLoaderRoute: typeof AdminLayoutForeignVendorsLayoutIndexRouteImport
      parentRoute: typeof AdminLayoutForeignVendorsLayoutRoute
    }
    '/admin/_layout/error-logs/_layout/': {
      id: '/admin/_layout/error-logs/_layout/'
      path: '/'
      fullPath: '/admin/error-logs/'
      preLoaderRoute: typeof AdminLayoutErrorLogsLayoutIndexRouteImport
      parentRoute: typeof AdminLayoutErrorLogsLayoutRoute
    }
    '/admin/_layout/contracts/_layout/': {
      id: '/admin/_layout/contracts/_layout/'
      path: '/'
      fullPath: '/admin/contracts/'
      preLoaderRoute: typeof AdminLayoutContractsLayoutIndexRouteImport
      parentRoute: typeof AdminLayoutContractsLayoutRoute
    }
    '/admin/_layout/commissions/_layout/': {
      id: '/admin/_layout/commissions/_layout/'
      path: '/'
      fullPath: '/admin/commissions/'
      preLoaderRoute: typeof AdminLayoutCommissionsLayoutIndexRouteImport
      parentRoute: typeof AdminLayoutCommissionsLayoutRoute
    }
    '/admin/_layout/appointee/_layout/': {
      id: '/admin/_layout/appointee/_layout/'
      path: '/'
      fullPath: '/admin/appointee/'
      preLoaderRoute: typeof AdminLayoutAppointeeLayoutIndexRouteImport
      parentRoute: typeof AdminLayoutAppointeeLayoutRoute
    }
    '/admin/_layout/advisors/_layout/': {
      id: '/admin/_layout/advisors/_layout/'
      path: '/'
      fullPath: '/admin/advisors/'
      preLoaderRoute: typeof AdminLayoutAdvisorsLayoutIndexRouteImport
      parentRoute: typeof AdminLayoutAdvisorsLayoutRoute
    }
    '/admin/_layout/admins/_layout/': {
      id: '/admin/_layout/admins/_layout/'
      path: '/'
      fullPath: '/admin/admins/'
      preLoaderRoute: typeof AdminLayoutAdminsLayoutIndexRouteImport
      parentRoute: typeof AdminLayoutAdminsLayoutRoute
    }
    '/admin/_layout/acube-payments/_layout/': {
      id: '/admin/_layout/acube-payments/_layout/'
      path: '/'
      fullPath: '/admin/acube-payments/'
      preLoaderRoute: typeof AdminLayoutAcubePaymentsLayoutIndexRouteImport
      parentRoute: typeof AdminLayoutAcubePaymentsLayoutRoute
    }
    '/admin/_layout/acube-jobs/_layout/': {
      id: '/admin/_layout/acube-jobs/_layout/'
      path: '/'
      fullPath: '/admin/acube-jobs/'
      preLoaderRoute: typeof AdminLayoutAcubeJobsLayoutIndexRouteImport
      parentRoute: typeof AdminLayoutAcubeJobsLayoutRoute
    }
    '/referrer/_layout/tenants/_layout/$id': {
      id: '/referrer/_layout/tenants/_layout/$id'
      path: '/$id'
      fullPath: '/referrer/tenants/$id'
      preLoaderRoute: typeof ReferrerLayoutTenantsLayoutIdRouteImport
      parentRoute: typeof ReferrerLayoutTenantsLayoutRoute
    }
    '/referrer/_layout/contracts/_layout/new': {
      id: '/referrer/_layout/contracts/_layout/new'
      path: '/new'
      fullPath: '/referrer/contracts/new'
      preLoaderRoute: typeof ReferrerLayoutContractsLayoutNewRouteImport
      parentRoute: typeof ReferrerLayoutContractsLayoutRoute
    }
    '/referrer/_layout/contracts/_layout/$id': {
      id: '/referrer/_layout/contracts/_layout/$id'
      path: '/$id'
      fullPath: '/referrer/contracts/$id'
      preLoaderRoute: typeof ReferrerLayoutContractsLayoutIdRouteImport
      parentRoute: typeof ReferrerLayoutContractsLayoutRoute
    }
    '/referrer/_layout/commissions/_layout/$id': {
      id: '/referrer/_layout/commissions/_layout/$id'
      path: '/$id'
      fullPath: '/referrer/commissions/$id'
      preLoaderRoute: typeof ReferrerLayoutCommissionsLayoutIdRouteImport
      parentRoute: typeof ReferrerLayoutCommissionsLayoutRoute
    }
    '/referrer/_layout/agents/_layout/new': {
      id: '/referrer/_layout/agents/_layout/new'
      path: '/new'
      fullPath: '/referrer/agents/new'
      preLoaderRoute: typeof ReferrerLayoutAgentsLayoutNewRouteImport
      parentRoute: typeof ReferrerLayoutAgentsLayoutRoute
    }
    '/referrer/_layout/agents/_layout/$id': {
      id: '/referrer/_layout/agents/_layout/$id'
      path: '/$id'
      fullPath: '/referrer/agents/$id'
      preLoaderRoute: typeof ReferrerLayoutAgentsLayoutIdRouteImport
      parentRoute: typeof ReferrerLayoutAgentsLayoutRoute
    }
    '/admin/_layout/tickets/_layout/$id': {
      id: '/admin/_layout/tickets/_layout/$id'
      path: '/$id'
      fullPath: '/admin/tickets/$id'
      preLoaderRoute: typeof AdminLayoutTicketsLayoutIdRouteImport
      parentRoute: typeof AdminLayoutTicketsLayoutRoute
    }
    '/admin/_layout/tenants/_layout/$id': {
      id: '/admin/_layout/tenants/_layout/$id'
      path: '/$id'
      fullPath: '/admin/tenants/$id'
      preLoaderRoute: typeof AdminLayoutTenantsLayoutIdRouteImport
      parentRoute: typeof AdminLayoutTenantsLayoutRoute
    }
    '/admin/_layout/system-monitor/_layout/redis': {
      id: '/admin/_layout/system-monitor/_layout/redis'
      path: '/redis'
      fullPath: '/admin/system-monitor/redis'
      preLoaderRoute: typeof AdminLayoutSystemMonitorLayoutRedisRouteImport
      parentRoute: typeof AdminLayoutSystemMonitorLayoutRoute
    }
    '/admin/_layout/system-monitor/_layout/queues': {
      id: '/admin/_layout/system-monitor/_layout/queues'
      path: '/queues'
      fullPath: '/admin/system-monitor/queues'
      preLoaderRoute: typeof AdminLayoutSystemMonitorLayoutQueuesRouteImport
      parentRoute: typeof AdminLayoutSystemMonitorLayoutRoute
    }
    '/admin/_layout/system-monitor/_layout/overview': {
      id: '/admin/_layout/system-monitor/_layout/overview'
      path: '/overview'
      fullPath: '/admin/system-monitor/overview'
      preLoaderRoute: typeof AdminLayoutSystemMonitorLayoutOverviewRouteImport
      parentRoute: typeof AdminLayoutSystemMonitorLayoutRoute
    }
    '/admin/_layout/system-monitor/_layout/metrics': {
      id: '/admin/_layout/system-monitor/_layout/metrics'
      path: '/metrics'
      fullPath: '/admin/system-monitor/metrics'
      preLoaderRoute: typeof AdminLayoutSystemMonitorLayoutMetricsRouteImport
      parentRoute: typeof AdminLayoutSystemMonitorLayoutRoute
    }
    '/admin/_layout/service-usage/_layout/$tenantId': {
      id: '/admin/_layout/service-usage/_layout/$tenantId'
      path: '/$tenantId'
      fullPath: '/admin/service-usage/$tenantId'
      preLoaderRoute: typeof AdminLayoutServiceUsageLayoutTenantIdRouteImport
      parentRoute: typeof AdminLayoutServiceUsageLayoutRoute
    }
    '/admin/_layout/referrers/_layout/new-partner': {
      id: '/admin/_layout/referrers/_layout/new-partner'
      path: '/new-partner'
      fullPath: '/admin/referrers/new-partner'
      preLoaderRoute: typeof AdminLayoutReferrersLayoutNewPartnerRouteImport
      parentRoute: typeof AdminLayoutReferrersLayoutRoute
    }
    '/admin/_layout/referrers/_layout/new': {
      id: '/admin/_layout/referrers/_layout/new'
      path: '/new'
      fullPath: '/admin/referrers/new'
      preLoaderRoute: typeof AdminLayoutReferrersLayoutNewRouteImport
      parentRoute: typeof AdminLayoutReferrersLayoutRoute
    }
    '/admin/_layout/referrers/_layout/$id': {
      id: '/admin/_layout/referrers/_layout/$id'
      path: '/$id'
      fullPath: '/admin/referrers/$id'
      preLoaderRoute: typeof AdminLayoutReferrersLayoutIdRouteImport
      parentRoute: typeof AdminLayoutReferrersLayoutRoute
    }
    '/admin/_layout/notifications/_layout/$id': {
      id: '/admin/_layout/notifications/_layout/$id'
      path: '/$id'
      fullPath: '/admin/notifications/$id'
      preLoaderRoute: typeof AdminLayoutNotificationsLayoutIdRouteImport
      parentRoute: typeof AdminLayoutNotificationsLayoutRoute
    }
    '/admin/_layout/mcp-clients/_layout/$id': {
      id: '/admin/_layout/mcp-clients/_layout/$id'
      path: '/$id'
      fullPath: '/admin/mcp-clients/$id'
      preLoaderRoute: typeof AdminLayoutMcpClientsLayoutIdRouteImport
      parentRoute: typeof AdminLayoutMcpClientsLayoutRoute
    }
    '/admin/_layout/foreign-vendors/_layout/new': {
      id: '/admin/_layout/foreign-vendors/_layout/new'
      path: '/new'
      fullPath: '/admin/foreign-vendors/new'
      preLoaderRoute: typeof AdminLayoutForeignVendorsLayoutNewRouteImport
      parentRoute: typeof AdminLayoutForeignVendorsLayoutRoute
    }
    '/admin/_layout/error-logs/_layout/$id': {
      id: '/admin/_layout/error-logs/_layout/$id'
      path: '/$id'
      fullPath: '/admin/error-logs/$id'
      preLoaderRoute: typeof AdminLayoutErrorLogsLayoutIdRouteImport
      parentRoute: typeof AdminLayoutErrorLogsLayoutRoute
    }
    '/admin/_layout/contracts/_layout/new': {
      id: '/admin/_layout/contracts/_layout/new'
      path: '/new'
      fullPath: '/admin/contracts/new'
      preLoaderRoute: typeof AdminLayoutContractsLayoutNewRouteImport
      parentRoute: typeof AdminLayoutContractsLayoutRoute
    }
    '/admin/_layout/contracts/_layout/$id': {
      id: '/admin/_layout/contracts/_layout/$id'
      path: '/$id'
      fullPath: '/admin/contracts/$id'
      preLoaderRoute: typeof AdminLayoutContractsLayoutIdRouteImport
      parentRoute: typeof AdminLayoutContractsLayoutRoute
    }
    '/admin/_layout/commissions/_layout/$id': {
      id: '/admin/_layout/commissions/_layout/$id'
      path: '/$id'
      fullPath: '/admin/commissions/$id'
      preLoaderRoute: typeof AdminLayoutCommissionsLayoutIdRouteImport
      parentRoute: typeof AdminLayoutCommissionsLayoutRoute
    }
    '/admin/_layout/appointee/_layout/credentials': {
      id: '/admin/_layout/appointee/_layout/credentials'
      path: '/credentials'
      fullPath: '/admin/appointee/credentials'
      preLoaderRoute: typeof AdminLayoutAppointeeLayoutCredentialsRouteImport
      parentRoute: typeof AdminLayoutAppointeeLayoutRoute
    }
    '/admin/_layout/appointee/_layout/$id': {
      id: '/admin/_layout/appointee/_layout/$id'
      path: '/$id'
      fullPath: '/admin/appointee/$id'
      preLoaderRoute: typeof AdminLayoutAppointeeLayoutIdRouteImport
      parentRoute: typeof AdminLayoutAppointeeLayoutRoute
    }
    '/admin/_layout/advisors/_layout/new': {
      id: '/admin/_layout/advisors/_layout/new'
      path: '/new'
      fullPath: '/admin/advisors/new'
      preLoaderRoute: typeof AdminLayoutAdvisorsLayoutNewRouteImport
      parentRoute: typeof AdminLayoutAdvisorsLayoutRoute
    }
    '/admin/_layout/advisors/_layout/$id': {
      id: '/admin/_layout/advisors/_layout/$id'
      path: '/$id'
      fullPath: '/admin/advisors/$id'
      preLoaderRoute: typeof AdminLayoutAdvisorsLayoutIdRouteImport
      parentRoute: typeof AdminLayoutAdvisorsLayoutRoute
    }
    '/admin/_layout/admins/_layout/new': {
      id: '/admin/_layout/admins/_layout/new'
      path: '/new'
      fullPath: '/admin/admins/new'
      preLoaderRoute: typeof AdminLayoutAdminsLayoutNewRouteImport
      parentRoute: typeof AdminLayoutAdminsLayoutRoute
    }
    '/admin/_layout/acube-payments/_layout/$id': {
      id: '/admin/_layout/acube-payments/_layout/$id'
      path: '/$id'
      fullPath: '/admin/acube-payments/$id'
      preLoaderRoute: typeof AdminLayoutAcubePaymentsLayoutIdRouteImport
      parentRoute: typeof AdminLayoutAcubePaymentsLayoutRoute
    }
    '/admin/_layout/acube-jobs/_layout/$id': {
      id: '/admin/_layout/acube-jobs/_layout/$id'
      path: '/$id'
      fullPath: '/admin/acube-jobs/$id'
      preLoaderRoute: typeof AdminLayoutAcubeJobsLayoutIdRouteImport
      parentRoute: typeof AdminLayoutAcubeJobsLayoutRoute
    }
    '/referrer/_layout/contracts/_layout/$id_/edit': {
      id: '/referrer/_layout/contracts/_layout/$id_/edit'
      path: '/$id/edit'
      fullPath: '/referrer/contracts/$id/edit'
      preLoaderRoute: typeof ReferrerLayoutContractsLayoutIdEditRouteImport
      parentRoute: typeof ReferrerLayoutContractsLayoutRoute
    }
    '/admin/_layout/system-monitor/_layout/runs/_layout': {
      id: '/admin/_layout/system-monitor/_layout/runs/_layout'
      path: '/runs'
      fullPath: '/admin/system-monitor/runs'
      preLoaderRoute: typeof AdminLayoutSystemMonitorLayoutRunsLayoutRouteImport
      parentRoute: typeof AdminLayoutSystemMonitorLayoutRunsRoute
    }
    '/admin/_layout/system-monitor/_layout/job/$jobId': {
      id: '/admin/_layout/system-monitor/_layout/job/$jobId'
      path: '/job/$jobId'
      fullPath: '/admin/system-monitor/job/$jobId'
      preLoaderRoute: typeof AdminLayoutSystemMonitorLayoutJobJobIdRouteImport
      parentRoute: typeof AdminLayoutSystemMonitorLayoutRoute
    }
    '/admin/_layout/system-monitor/_layout/flow/$flowId': {
      id: '/admin/_layout/system-monitor/_layout/flow/$flowId'
      path: '/flow/$flowId'
      fullPath: '/admin/system-monitor/flow/$flowId'
      preLoaderRoute: typeof AdminLayoutSystemMonitorLayoutFlowFlowIdRouteImport
      parentRoute: typeof AdminLayoutSystemMonitorLayoutRoute
    }
    '/admin/_layout/referrers/_layout/edit/$id': {
      id: '/admin/_layout/referrers/_layout/edit/$id'
      path: '/edit/$id'
      fullPath: '/admin/referrers/edit/$id'
      preLoaderRoute: typeof AdminLayoutReferrersLayoutEditIdRouteImport
      parentRoute: typeof AdminLayoutReferrersLayoutRoute
    }
    '/admin/_layout/notifications/_layout/edit/$id': {
      id: '/admin/_layout/notifications/_layout/edit/$id'
      path: '/edit/$id'
      fullPath: '/admin/notifications/edit/$id'
      preLoaderRoute: typeof AdminLayoutNotificationsLayoutEditIdRouteImport
      parentRoute: typeof AdminLayoutNotificationsLayoutRoute
    }
    '/admin/_layout/foreign-vendors/_layout/edit/$id': {
      id: '/admin/_layout/foreign-vendors/_layout/edit/$id'
      path: '/edit/$id'
      fullPath: '/admin/foreign-vendors/edit/$id'
      preLoaderRoute: typeof AdminLayoutForeignVendorsLayoutEditIdRouteImport
      parentRoute: typeof AdminLayoutForeignVendorsLayoutRoute
    }
    '/admin/_layout/contracts/_layout/$id_/edit': {
      id: '/admin/_layout/contracts/_layout/$id_/edit'
      path: '/$id/edit'
      fullPath: '/admin/contracts/$id/edit'
      preLoaderRoute: typeof AdminLayoutContractsLayoutIdEditRouteImport
      parentRoute: typeof AdminLayoutContractsLayoutRoute
    }
    '/admin/_layout/advisors/_layout/edit/$id': {
      id: '/admin/_layout/advisors/_layout/edit/$id'
      path: '/edit/$id'
      fullPath: '/admin/advisors/edit/$id'
      preLoaderRoute: typeof AdminLayoutAdvisorsLayoutEditIdRouteImport
      parentRoute: typeof AdminLayoutAdvisorsLayoutRoute
    }
    '/admin/_layout/admins/_layout/edit/$id': {
      id: '/admin/_layout/admins/_layout/edit/$id'
      path: '/edit/$id'
      fullPath: '/admin/admins/edit/$id'
      preLoaderRoute: typeof AdminLayoutAdminsLayoutEditIdRouteImport
      parentRoute: typeof AdminLayoutAdminsLayoutRoute
    }
    '/admin/_layout/acube-payments/_layout/sepa/$id': {
      id: '/admin/_layout/acube-payments/_layout/sepa/$id'
      path: '/sepa/$id'
      fullPath: '/admin/acube-payments/sepa/$id'
      preLoaderRoute: typeof AdminLayoutAcubePaymentsLayoutSepaIdRouteImport
      parentRoute: typeof AdminLayoutAcubePaymentsLayoutRoute
    }
    '/admin/_layout/system-monitor/_layout/runs/_layout/': {
      id: '/admin/_layout/system-monitor/_layout/runs/_layout/'
      path: '/'
      fullPath: '/admin/system-monitor/runs/'
      preLoaderRoute: typeof AdminLayoutSystemMonitorLayoutRunsLayoutIndexRouteImport
      parentRoute: typeof AdminLayoutSystemMonitorLayoutRunsLayoutRoute
    }
    '/admin/_layout/system-monitor/_layout/runs/_layout/$id': {
      id: '/admin/_layout/system-monitor/_layout/runs/_layout/$id'
      path: '/$id'
      fullPath: '/admin/system-monitor/runs/$id'
      preLoaderRoute: typeof AdminLayoutSystemMonitorLayoutRunsLayoutIdRouteImport
      parentRoute: typeof AdminLayoutSystemMonitorLayoutRunsLayoutRoute
    }
  }
}

interface AdminLayoutAcubeJobsLayoutRouteChildren {
  AdminLayoutAcubeJobsLayoutIdRoute: typeof AdminLayoutAcubeJobsLayoutIdRoute
  AdminLayoutAcubeJobsLayoutIndexRoute: typeof AdminLayoutAcubeJobsLayoutIndexRoute
}

const AdminLayoutAcubeJobsLayoutRouteChildren: AdminLayoutAcubeJobsLayoutRouteChildren =
  {
    AdminLayoutAcubeJobsLayoutIdRoute: AdminLayoutAcubeJobsLayoutIdRoute,
    AdminLayoutAcubeJobsLayoutIndexRoute: AdminLayoutAcubeJobsLayoutIndexRoute,
  }

const AdminLayoutAcubeJobsLayoutRouteWithChildren =
  AdminLayoutAcubeJobsLayoutRoute._addFileChildren(
    AdminLayoutAcubeJobsLayoutRouteChildren,
  )

interface AdminLayoutAcubeJobsRouteChildren {
  AdminLayoutAcubeJobsLayoutRoute: typeof AdminLayoutAcubeJobsLayoutRouteWithChildren
}

const AdminLayoutAcubeJobsRouteChildren: AdminLayoutAcubeJobsRouteChildren = {
  AdminLayoutAcubeJobsLayoutRoute: AdminLayoutAcubeJobsLayoutRouteWithChildren,
}

const AdminLayoutAcubeJobsRouteWithChildren =
  AdminLayoutAcubeJobsRoute._addFileChildren(AdminLayoutAcubeJobsRouteChildren)

interface AdminLayoutAcubePaymentsLayoutRouteChildren {
  AdminLayoutAcubePaymentsLayoutIdRoute: typeof AdminLayoutAcubePaymentsLayoutIdRoute
  AdminLayoutAcubePaymentsLayoutIndexRoute: typeof AdminLayoutAcubePaymentsLayoutIndexRoute
  AdminLayoutAcubePaymentsLayoutSepaIdRoute: typeof AdminLayoutAcubePaymentsLayoutSepaIdRoute
}

const AdminLayoutAcubePaymentsLayoutRouteChildren: AdminLayoutAcubePaymentsLayoutRouteChildren =
  {
    AdminLayoutAcubePaymentsLayoutIdRoute:
      AdminLayoutAcubePaymentsLayoutIdRoute,
    AdminLayoutAcubePaymentsLayoutIndexRoute:
      AdminLayoutAcubePaymentsLayoutIndexRoute,
    AdminLayoutAcubePaymentsLayoutSepaIdRoute:
      AdminLayoutAcubePaymentsLayoutSepaIdRoute,
  }

const AdminLayoutAcubePaymentsLayoutRouteWithChildren =
  AdminLayoutAcubePaymentsLayoutRoute._addFileChildren(
    AdminLayoutAcubePaymentsLayoutRouteChildren,
  )

interface AdminLayoutAcubePaymentsRouteChildren {
  AdminLayoutAcubePaymentsLayoutRoute: typeof AdminLayoutAcubePaymentsLayoutRouteWithChildren
}

const AdminLayoutAcubePaymentsRouteChildren: AdminLayoutAcubePaymentsRouteChildren =
  {
    AdminLayoutAcubePaymentsLayoutRoute:
      AdminLayoutAcubePaymentsLayoutRouteWithChildren,
  }

const AdminLayoutAcubePaymentsRouteWithChildren =
  AdminLayoutAcubePaymentsRoute._addFileChildren(
    AdminLayoutAcubePaymentsRouteChildren,
  )

interface AdminLayoutAdminsLayoutRouteChildren {
  AdminLayoutAdminsLayoutNewRoute: typeof AdminLayoutAdminsLayoutNewRoute
  AdminLayoutAdminsLayoutIndexRoute: typeof AdminLayoutAdminsLayoutIndexRoute
  AdminLayoutAdminsLayoutEditIdRoute: typeof AdminLayoutAdminsLayoutEditIdRoute
}

const AdminLayoutAdminsLayoutRouteChildren: AdminLayoutAdminsLayoutRouteChildren =
  {
    AdminLayoutAdminsLayoutNewRoute: AdminLayoutAdminsLayoutNewRoute,
    AdminLayoutAdminsLayoutIndexRoute: AdminLayoutAdminsLayoutIndexRoute,
    AdminLayoutAdminsLayoutEditIdRoute: AdminLayoutAdminsLayoutEditIdRoute,
  }

const AdminLayoutAdminsLayoutRouteWithChildren =
  AdminLayoutAdminsLayoutRoute._addFileChildren(
    AdminLayoutAdminsLayoutRouteChildren,
  )

interface AdminLayoutAdminsRouteChildren {
  AdminLayoutAdminsLayoutRoute: typeof AdminLayoutAdminsLayoutRouteWithChildren
}

const AdminLayoutAdminsRouteChildren: AdminLayoutAdminsRouteChildren = {
  AdminLayoutAdminsLayoutRoute: AdminLayoutAdminsLayoutRouteWithChildren,
}

const AdminLayoutAdminsRouteWithChildren =
  AdminLayoutAdminsRoute._addFileChildren(AdminLayoutAdminsRouteChildren)

interface AdminLayoutAdvisorsLayoutRouteChildren {
  AdminLayoutAdvisorsLayoutIdRoute: typeof AdminLayoutAdvisorsLayoutIdRoute
  AdminLayoutAdvisorsLayoutNewRoute: typeof AdminLayoutAdvisorsLayoutNewRoute
  AdminLayoutAdvisorsLayoutIndexRoute: typeof AdminLayoutAdvisorsLayoutIndexRoute
  AdminLayoutAdvisorsLayoutEditIdRoute: typeof AdminLayoutAdvisorsLayoutEditIdRoute
}

const AdminLayoutAdvisorsLayoutRouteChildren: AdminLayoutAdvisorsLayoutRouteChildren =
  {
    AdminLayoutAdvisorsLayoutIdRoute: AdminLayoutAdvisorsLayoutIdRoute,
    AdminLayoutAdvisorsLayoutNewRoute: AdminLayoutAdvisorsLayoutNewRoute,
    AdminLayoutAdvisorsLayoutIndexRoute: AdminLayoutAdvisorsLayoutIndexRoute,
    AdminLayoutAdvisorsLayoutEditIdRoute: AdminLayoutAdvisorsLayoutEditIdRoute,
  }

const AdminLayoutAdvisorsLayoutRouteWithChildren =
  AdminLayoutAdvisorsLayoutRoute._addFileChildren(
    AdminLayoutAdvisorsLayoutRouteChildren,
  )

interface AdminLayoutAdvisorsRouteChildren {
  AdminLayoutAdvisorsLayoutRoute: typeof AdminLayoutAdvisorsLayoutRouteWithChildren
}

const AdminLayoutAdvisorsRouteChildren: AdminLayoutAdvisorsRouteChildren = {
  AdminLayoutAdvisorsLayoutRoute: AdminLayoutAdvisorsLayoutRouteWithChildren,
}

const AdminLayoutAdvisorsRouteWithChildren =
  AdminLayoutAdvisorsRoute._addFileChildren(AdminLayoutAdvisorsRouteChildren)

interface AdminLayoutAppointeeLayoutRouteChildren {
  AdminLayoutAppointeeLayoutIdRoute: typeof AdminLayoutAppointeeLayoutIdRoute
  AdminLayoutAppointeeLayoutCredentialsRoute: typeof AdminLayoutAppointeeLayoutCredentialsRoute
  AdminLayoutAppointeeLayoutIndexRoute: typeof AdminLayoutAppointeeLayoutIndexRoute
}

const AdminLayoutAppointeeLayoutRouteChildren: AdminLayoutAppointeeLayoutRouteChildren =
  {
    AdminLayoutAppointeeLayoutIdRoute: AdminLayoutAppointeeLayoutIdRoute,
    AdminLayoutAppointeeLayoutCredentialsRoute:
      AdminLayoutAppointeeLayoutCredentialsRoute,
    AdminLayoutAppointeeLayoutIndexRoute: AdminLayoutAppointeeLayoutIndexRoute,
  }

const AdminLayoutAppointeeLayoutRouteWithChildren =
  AdminLayoutAppointeeLayoutRoute._addFileChildren(
    AdminLayoutAppointeeLayoutRouteChildren,
  )

interface AdminLayoutAppointeeRouteChildren {
  AdminLayoutAppointeeLayoutRoute: typeof AdminLayoutAppointeeLayoutRouteWithChildren
}

const AdminLayoutAppointeeRouteChildren: AdminLayoutAppointeeRouteChildren = {
  AdminLayoutAppointeeLayoutRoute: AdminLayoutAppointeeLayoutRouteWithChildren,
}

const AdminLayoutAppointeeRouteWithChildren =
  AdminLayoutAppointeeRoute._addFileChildren(AdminLayoutAppointeeRouteChildren)

interface AdminLayoutCommissionsLayoutRouteChildren {
  AdminLayoutCommissionsLayoutIdRoute: typeof AdminLayoutCommissionsLayoutIdRoute
  AdminLayoutCommissionsLayoutIndexRoute: typeof AdminLayoutCommissionsLayoutIndexRoute
}

const AdminLayoutCommissionsLayoutRouteChildren: AdminLayoutCommissionsLayoutRouteChildren =
  {
    AdminLayoutCommissionsLayoutIdRoute: AdminLayoutCommissionsLayoutIdRoute,
    AdminLayoutCommissionsLayoutIndexRoute:
      AdminLayoutCommissionsLayoutIndexRoute,
  }

const AdminLayoutCommissionsLayoutRouteWithChildren =
  AdminLayoutCommissionsLayoutRoute._addFileChildren(
    AdminLayoutCommissionsLayoutRouteChildren,
  )

interface AdminLayoutCommissionsRouteChildren {
  AdminLayoutCommissionsLayoutRoute: typeof AdminLayoutCommissionsLayoutRouteWithChildren
}

const AdminLayoutCommissionsRouteChildren: AdminLayoutCommissionsRouteChildren =
  {
    AdminLayoutCommissionsLayoutRoute:
      AdminLayoutCommissionsLayoutRouteWithChildren,
  }

const AdminLayoutCommissionsRouteWithChildren =
  AdminLayoutCommissionsRoute._addFileChildren(
    AdminLayoutCommissionsRouteChildren,
  )

interface AdminLayoutContractsLayoutRouteChildren {
  AdminLayoutContractsLayoutIdRoute: typeof AdminLayoutContractsLayoutIdRoute
  AdminLayoutContractsLayoutNewRoute: typeof AdminLayoutContractsLayoutNewRoute
  AdminLayoutContractsLayoutIndexRoute: typeof AdminLayoutContractsLayoutIndexRoute
  AdminLayoutContractsLayoutIdEditRoute: typeof AdminLayoutContractsLayoutIdEditRoute
}

const AdminLayoutContractsLayoutRouteChildren: AdminLayoutContractsLayoutRouteChildren =
  {
    AdminLayoutContractsLayoutIdRoute: AdminLayoutContractsLayoutIdRoute,
    AdminLayoutContractsLayoutNewRoute: AdminLayoutContractsLayoutNewRoute,
    AdminLayoutContractsLayoutIndexRoute: AdminLayoutContractsLayoutIndexRoute,
    AdminLayoutContractsLayoutIdEditRoute:
      AdminLayoutContractsLayoutIdEditRoute,
  }

const AdminLayoutContractsLayoutRouteWithChildren =
  AdminLayoutContractsLayoutRoute._addFileChildren(
    AdminLayoutContractsLayoutRouteChildren,
  )

interface AdminLayoutContractsRouteChildren {
  AdminLayoutContractsLayoutRoute: typeof AdminLayoutContractsLayoutRouteWithChildren
}

const AdminLayoutContractsRouteChildren: AdminLayoutContractsRouteChildren = {
  AdminLayoutContractsLayoutRoute: AdminLayoutContractsLayoutRouteWithChildren,
}

const AdminLayoutContractsRouteWithChildren =
  AdminLayoutContractsRoute._addFileChildren(AdminLayoutContractsRouteChildren)

interface AdminLayoutErrorLogsLayoutRouteChildren {
  AdminLayoutErrorLogsLayoutIdRoute: typeof AdminLayoutErrorLogsLayoutIdRoute
  AdminLayoutErrorLogsLayoutIndexRoute: typeof AdminLayoutErrorLogsLayoutIndexRoute
}

const AdminLayoutErrorLogsLayoutRouteChildren: AdminLayoutErrorLogsLayoutRouteChildren =
  {
    AdminLayoutErrorLogsLayoutIdRoute: AdminLayoutErrorLogsLayoutIdRoute,
    AdminLayoutErrorLogsLayoutIndexRoute: AdminLayoutErrorLogsLayoutIndexRoute,
  }

const AdminLayoutErrorLogsLayoutRouteWithChildren =
  AdminLayoutErrorLogsLayoutRoute._addFileChildren(
    AdminLayoutErrorLogsLayoutRouteChildren,
  )

interface AdminLayoutErrorLogsRouteChildren {
  AdminLayoutErrorLogsLayoutRoute: typeof AdminLayoutErrorLogsLayoutRouteWithChildren
}

const AdminLayoutErrorLogsRouteChildren: AdminLayoutErrorLogsRouteChildren = {
  AdminLayoutErrorLogsLayoutRoute: AdminLayoutErrorLogsLayoutRouteWithChildren,
}

const AdminLayoutErrorLogsRouteWithChildren =
  AdminLayoutErrorLogsRoute._addFileChildren(AdminLayoutErrorLogsRouteChildren)

interface AdminLayoutForeignVendorsLayoutRouteChildren {
  AdminLayoutForeignVendorsLayoutNewRoute: typeof AdminLayoutForeignVendorsLayoutNewRoute
  AdminLayoutForeignVendorsLayoutIndexRoute: typeof AdminLayoutForeignVendorsLayoutIndexRoute
  AdminLayoutForeignVendorsLayoutEditIdRoute: typeof AdminLayoutForeignVendorsLayoutEditIdRoute
}

const AdminLayoutForeignVendorsLayoutRouteChildren: AdminLayoutForeignVendorsLayoutRouteChildren =
  {
    AdminLayoutForeignVendorsLayoutNewRoute:
      AdminLayoutForeignVendorsLayoutNewRoute,
    AdminLayoutForeignVendorsLayoutIndexRoute:
      AdminLayoutForeignVendorsLayoutIndexRoute,
    AdminLayoutForeignVendorsLayoutEditIdRoute:
      AdminLayoutForeignVendorsLayoutEditIdRoute,
  }

const AdminLayoutForeignVendorsLayoutRouteWithChildren =
  AdminLayoutForeignVendorsLayoutRoute._addFileChildren(
    AdminLayoutForeignVendorsLayoutRouteChildren,
  )

interface AdminLayoutForeignVendorsRouteChildren {
  AdminLayoutForeignVendorsLayoutRoute: typeof AdminLayoutForeignVendorsLayoutRouteWithChildren
}

const AdminLayoutForeignVendorsRouteChildren: AdminLayoutForeignVendorsRouteChildren =
  {
    AdminLayoutForeignVendorsLayoutRoute:
      AdminLayoutForeignVendorsLayoutRouteWithChildren,
  }

const AdminLayoutForeignVendorsRouteWithChildren =
  AdminLayoutForeignVendorsRoute._addFileChildren(
    AdminLayoutForeignVendorsRouteChildren,
  )

interface AdminLayoutMcpClientsLayoutRouteChildren {
  AdminLayoutMcpClientsLayoutIdRoute: typeof AdminLayoutMcpClientsLayoutIdRoute
  AdminLayoutMcpClientsLayoutIndexRoute: typeof AdminLayoutMcpClientsLayoutIndexRoute
}

const AdminLayoutMcpClientsLayoutRouteChildren: AdminLayoutMcpClientsLayoutRouteChildren =
  {
    AdminLayoutMcpClientsLayoutIdRoute: AdminLayoutMcpClientsLayoutIdRoute,
    AdminLayoutMcpClientsLayoutIndexRoute:
      AdminLayoutMcpClientsLayoutIndexRoute,
  }

const AdminLayoutMcpClientsLayoutRouteWithChildren =
  AdminLayoutMcpClientsLayoutRoute._addFileChildren(
    AdminLayoutMcpClientsLayoutRouteChildren,
  )

interface AdminLayoutMcpClientsRouteChildren {
  AdminLayoutMcpClientsLayoutRoute: typeof AdminLayoutMcpClientsLayoutRouteWithChildren
}

const AdminLayoutMcpClientsRouteChildren: AdminLayoutMcpClientsRouteChildren = {
  AdminLayoutMcpClientsLayoutRoute:
    AdminLayoutMcpClientsLayoutRouteWithChildren,
}

const AdminLayoutMcpClientsRouteWithChildren =
  AdminLayoutMcpClientsRoute._addFileChildren(
    AdminLayoutMcpClientsRouteChildren,
  )

interface AdminLayoutNotificationsLayoutRouteChildren {
  AdminLayoutNotificationsLayoutIdRoute: typeof AdminLayoutNotificationsLayoutIdRoute
  AdminLayoutNotificationsLayoutIndexRoute: typeof AdminLayoutNotificationsLayoutIndexRoute
  AdminLayoutNotificationsLayoutEditIdRoute: typeof AdminLayoutNotificationsLayoutEditIdRoute
}

const AdminLayoutNotificationsLayoutRouteChildren: AdminLayoutNotificationsLayoutRouteChildren =
  {
    AdminLayoutNotificationsLayoutIdRoute:
      AdminLayoutNotificationsLayoutIdRoute,
    AdminLayoutNotificationsLayoutIndexRoute:
      AdminLayoutNotificationsLayoutIndexRoute,
    AdminLayoutNotificationsLayoutEditIdRoute:
      AdminLayoutNotificationsLayoutEditIdRoute,
  }

const AdminLayoutNotificationsLayoutRouteWithChildren =
  AdminLayoutNotificationsLayoutRoute._addFileChildren(
    AdminLayoutNotificationsLayoutRouteChildren,
  )

interface AdminLayoutNotificationsRouteChildren {
  AdminLayoutNotificationsLayoutRoute: typeof AdminLayoutNotificationsLayoutRouteWithChildren
}

const AdminLayoutNotificationsRouteChildren: AdminLayoutNotificationsRouteChildren =
  {
    AdminLayoutNotificationsLayoutRoute:
      AdminLayoutNotificationsLayoutRouteWithChildren,
  }

const AdminLayoutNotificationsRouteWithChildren =
  AdminLayoutNotificationsRoute._addFileChildren(
    AdminLayoutNotificationsRouteChildren,
  )

interface AdminLayoutReferrersLayoutRouteChildren {
  AdminLayoutReferrersLayoutIdRoute: typeof AdminLayoutReferrersLayoutIdRoute
  AdminLayoutReferrersLayoutNewRoute: typeof AdminLayoutReferrersLayoutNewRoute
  AdminLayoutReferrersLayoutNewPartnerRoute: typeof AdminLayoutReferrersLayoutNewPartnerRoute
  AdminLayoutReferrersLayoutIndexRoute: typeof AdminLayoutReferrersLayoutIndexRoute
  AdminLayoutReferrersLayoutEditIdRoute: typeof AdminLayoutReferrersLayoutEditIdRoute
}

const AdminLayoutReferrersLayoutRouteChildren: AdminLayoutReferrersLayoutRouteChildren =
  {
    AdminLayoutReferrersLayoutIdRoute: AdminLayoutReferrersLayoutIdRoute,
    AdminLayoutReferrersLayoutNewRoute: AdminLayoutReferrersLayoutNewRoute,
    AdminLayoutReferrersLayoutNewPartnerRoute:
      AdminLayoutReferrersLayoutNewPartnerRoute,
    AdminLayoutReferrersLayoutIndexRoute: AdminLayoutReferrersLayoutIndexRoute,
    AdminLayoutReferrersLayoutEditIdRoute:
      AdminLayoutReferrersLayoutEditIdRoute,
  }

const AdminLayoutReferrersLayoutRouteWithChildren =
  AdminLayoutReferrersLayoutRoute._addFileChildren(
    AdminLayoutReferrersLayoutRouteChildren,
  )

interface AdminLayoutReferrersRouteChildren {
  AdminLayoutReferrersLayoutRoute: typeof AdminLayoutReferrersLayoutRouteWithChildren
}

const AdminLayoutReferrersRouteChildren: AdminLayoutReferrersRouteChildren = {
  AdminLayoutReferrersLayoutRoute: AdminLayoutReferrersLayoutRouteWithChildren,
}

const AdminLayoutReferrersRouteWithChildren =
  AdminLayoutReferrersRoute._addFileChildren(AdminLayoutReferrersRouteChildren)

interface AdminLayoutServiceUsageLayoutRouteChildren {
  AdminLayoutServiceUsageLayoutTenantIdRoute: typeof AdminLayoutServiceUsageLayoutTenantIdRoute
  AdminLayoutServiceUsageLayoutIndexRoute: typeof AdminLayoutServiceUsageLayoutIndexRoute
}

const AdminLayoutServiceUsageLayoutRouteChildren: AdminLayoutServiceUsageLayoutRouteChildren =
  {
    AdminLayoutServiceUsageLayoutTenantIdRoute:
      AdminLayoutServiceUsageLayoutTenantIdRoute,
    AdminLayoutServiceUsageLayoutIndexRoute:
      AdminLayoutServiceUsageLayoutIndexRoute,
  }

const AdminLayoutServiceUsageLayoutRouteWithChildren =
  AdminLayoutServiceUsageLayoutRoute._addFileChildren(
    AdminLayoutServiceUsageLayoutRouteChildren,
  )

interface AdminLayoutServiceUsageRouteChildren {
  AdminLayoutServiceUsageLayoutRoute: typeof AdminLayoutServiceUsageLayoutRouteWithChildren
  AdminLayoutServiceUsageByServiceRoute: typeof AdminLayoutServiceUsageByServiceRoute
}

const AdminLayoutServiceUsageRouteChildren: AdminLayoutServiceUsageRouteChildren =
  {
    AdminLayoutServiceUsageLayoutRoute:
      AdminLayoutServiceUsageLayoutRouteWithChildren,
    AdminLayoutServiceUsageByServiceRoute:
      AdminLayoutServiceUsageByServiceRoute,
  }

const AdminLayoutServiceUsageRouteWithChildren =
  AdminLayoutServiceUsageRoute._addFileChildren(
    AdminLayoutServiceUsageRouteChildren,
  )

interface AdminLayoutSystemMonitorLayoutRunsLayoutRouteChildren {
  AdminLayoutSystemMonitorLayoutRunsLayoutIdRoute: typeof AdminLayoutSystemMonitorLayoutRunsLayoutIdRoute
  AdminLayoutSystemMonitorLayoutRunsLayoutIndexRoute: typeof AdminLayoutSystemMonitorLayoutRunsLayoutIndexRoute
}

const AdminLayoutSystemMonitorLayoutRunsLayoutRouteChildren: AdminLayoutSystemMonitorLayoutRunsLayoutRouteChildren =
  {
    AdminLayoutSystemMonitorLayoutRunsLayoutIdRoute:
      AdminLayoutSystemMonitorLayoutRunsLayoutIdRoute,
    AdminLayoutSystemMonitorLayoutRunsLayoutIndexRoute:
      AdminLayoutSystemMonitorLayoutRunsLayoutIndexRoute,
  }

const AdminLayoutSystemMonitorLayoutRunsLayoutRouteWithChildren =
  AdminLayoutSystemMonitorLayoutRunsLayoutRoute._addFileChildren(
    AdminLayoutSystemMonitorLayoutRunsLayoutRouteChildren,
  )

interface AdminLayoutSystemMonitorLayoutRunsRouteChildren {
  AdminLayoutSystemMonitorLayoutRunsLayoutRoute: typeof AdminLayoutSystemMonitorLayoutRunsLayoutRouteWithChildren
}

const AdminLayoutSystemMonitorLayoutRunsRouteChildren: AdminLayoutSystemMonitorLayoutRunsRouteChildren =
  {
    AdminLayoutSystemMonitorLayoutRunsLayoutRoute:
      AdminLayoutSystemMonitorLayoutRunsLayoutRouteWithChildren,
  }

const AdminLayoutSystemMonitorLayoutRunsRouteWithChildren =
  AdminLayoutSystemMonitorLayoutRunsRoute._addFileChildren(
    AdminLayoutSystemMonitorLayoutRunsRouteChildren,
  )

interface AdminLayoutSystemMonitorLayoutRouteChildren {
  AdminLayoutSystemMonitorLayoutMetricsRoute: typeof AdminLayoutSystemMonitorLayoutMetricsRoute
  AdminLayoutSystemMonitorLayoutOverviewRoute: typeof AdminLayoutSystemMonitorLayoutOverviewRoute
  AdminLayoutSystemMonitorLayoutQueuesRoute: typeof AdminLayoutSystemMonitorLayoutQueuesRoute
  AdminLayoutSystemMonitorLayoutRedisRoute: typeof AdminLayoutSystemMonitorLayoutRedisRoute
  AdminLayoutSystemMonitorLayoutIndexRoute: typeof AdminLayoutSystemMonitorLayoutIndexRoute
  AdminLayoutSystemMonitorLayoutFlowFlowIdRoute: typeof AdminLayoutSystemMonitorLayoutFlowFlowIdRoute
  AdminLayoutSystemMonitorLayoutJobJobIdRoute: typeof AdminLayoutSystemMonitorLayoutJobJobIdRoute
  AdminLayoutSystemMonitorLayoutRunsRoute: typeof AdminLayoutSystemMonitorLayoutRunsRouteWithChildren
}

const AdminLayoutSystemMonitorLayoutRouteChildren: AdminLayoutSystemMonitorLayoutRouteChildren =
  {
    AdminLayoutSystemMonitorLayoutMetricsRoute:
      AdminLayoutSystemMonitorLayoutMetricsRoute,
    AdminLayoutSystemMonitorLayoutOverviewRoute:
      AdminLayoutSystemMonitorLayoutOverviewRoute,
    AdminLayoutSystemMonitorLayoutQueuesRoute:
      AdminLayoutSystemMonitorLayoutQueuesRoute,
    AdminLayoutSystemMonitorLayoutRedisRoute:
      AdminLayoutSystemMonitorLayoutRedisRoute,
    AdminLayoutSystemMonitorLayoutIndexRoute:
      AdminLayoutSystemMonitorLayoutIndexRoute,
    AdminLayoutSystemMonitorLayoutFlowFlowIdRoute:
      AdminLayoutSystemMonitorLayoutFlowFlowIdRoute,
    AdminLayoutSystemMonitorLayoutJobJobIdRoute:
      AdminLayoutSystemMonitorLayoutJobJobIdRoute,
    AdminLayoutSystemMonitorLayoutRunsRoute:
      AdminLayoutSystemMonitorLayoutRunsRouteWithChildren,
  }

const AdminLayoutSystemMonitorLayoutRouteWithChildren =
  AdminLayoutSystemMonitorLayoutRoute._addFileChildren(
    AdminLayoutSystemMonitorLayoutRouteChildren,
  )

interface AdminLayoutSystemMonitorRouteChildren {
  AdminLayoutSystemMonitorLayoutRoute: typeof AdminLayoutSystemMonitorLayoutRouteWithChildren
}

const AdminLayoutSystemMonitorRouteChildren: AdminLayoutSystemMonitorRouteChildren =
  {
    AdminLayoutSystemMonitorLayoutRoute:
      AdminLayoutSystemMonitorLayoutRouteWithChildren,
  }

const AdminLayoutSystemMonitorRouteWithChildren =
  AdminLayoutSystemMonitorRoute._addFileChildren(
    AdminLayoutSystemMonitorRouteChildren,
  )

interface AdminLayoutTenantsLayoutRouteChildren {
  AdminLayoutTenantsLayoutIdRoute: typeof AdminLayoutTenantsLayoutIdRoute
  AdminLayoutTenantsLayoutIndexRoute: typeof AdminLayoutTenantsLayoutIndexRoute
}

const AdminLayoutTenantsLayoutRouteChildren: AdminLayoutTenantsLayoutRouteChildren =
  {
    AdminLayoutTenantsLayoutIdRoute: AdminLayoutTenantsLayoutIdRoute,
    AdminLayoutTenantsLayoutIndexRoute: AdminLayoutTenantsLayoutIndexRoute,
  }

const AdminLayoutTenantsLayoutRouteWithChildren =
  AdminLayoutTenantsLayoutRoute._addFileChildren(
    AdminLayoutTenantsLayoutRouteChildren,
  )

interface AdminLayoutTenantsRouteChildren {
  AdminLayoutTenantsLayoutRoute: typeof AdminLayoutTenantsLayoutRouteWithChildren
}

const AdminLayoutTenantsRouteChildren: AdminLayoutTenantsRouteChildren = {
  AdminLayoutTenantsLayoutRoute: AdminLayoutTenantsLayoutRouteWithChildren,
}

const AdminLayoutTenantsRouteWithChildren =
  AdminLayoutTenantsRoute._addFileChildren(AdminLayoutTenantsRouteChildren)

interface AdminLayoutTicketsLayoutRouteChildren {
  AdminLayoutTicketsLayoutIdRoute: typeof AdminLayoutTicketsLayoutIdRoute
  AdminLayoutTicketsLayoutIndexRoute: typeof AdminLayoutTicketsLayoutIndexRoute
}

const AdminLayoutTicketsLayoutRouteChildren: AdminLayoutTicketsLayoutRouteChildren =
  {
    AdminLayoutTicketsLayoutIdRoute: AdminLayoutTicketsLayoutIdRoute,
    AdminLayoutTicketsLayoutIndexRoute: AdminLayoutTicketsLayoutIndexRoute,
  }

const AdminLayoutTicketsLayoutRouteWithChildren =
  AdminLayoutTicketsLayoutRoute._addFileChildren(
    AdminLayoutTicketsLayoutRouteChildren,
  )

interface AdminLayoutTicketsRouteChildren {
  AdminLayoutTicketsLayoutRoute: typeof AdminLayoutTicketsLayoutRouteWithChildren
}

const AdminLayoutTicketsRouteChildren: AdminLayoutTicketsRouteChildren = {
  AdminLayoutTicketsLayoutRoute: AdminLayoutTicketsLayoutRouteWithChildren,
}

const AdminLayoutTicketsRouteWithChildren =
  AdminLayoutTicketsRoute._addFileChildren(AdminLayoutTicketsRouteChildren)

interface AdminLayoutRouteChildren {
  AdminLayoutDashboardRoute: typeof AdminLayoutDashboardRoute
  AdminLayoutAcubeJobsRoute: typeof AdminLayoutAcubeJobsRouteWithChildren
  AdminLayoutAcubePaymentsRoute: typeof AdminLayoutAcubePaymentsRouteWithChildren
  AdminLayoutAdminsRoute: typeof AdminLayoutAdminsRouteWithChildren
  AdminLayoutAdvisorsRoute: typeof AdminLayoutAdvisorsRouteWithChildren
  AdminLayoutAppointeeRoute: typeof AdminLayoutAppointeeRouteWithChildren
  AdminLayoutCommissionsRoute: typeof AdminLayoutCommissionsRouteWithChildren
  AdminLayoutContractsRoute: typeof AdminLayoutContractsRouteWithChildren
  AdminLayoutErrorLogsRoute: typeof AdminLayoutErrorLogsRouteWithChildren
  AdminLayoutForeignVendorsRoute: typeof AdminLayoutForeignVendorsRouteWithChildren
  AdminLayoutMcpClientsRoute: typeof AdminLayoutMcpClientsRouteWithChildren
  AdminLayoutNotificationsRoute: typeof AdminLayoutNotificationsRouteWithChildren
  AdminLayoutReferrersRoute: typeof AdminLayoutReferrersRouteWithChildren
  AdminLayoutServiceUsageRoute: typeof AdminLayoutServiceUsageRouteWithChildren
  AdminLayoutSystemMonitorRoute: typeof AdminLayoutSystemMonitorRouteWithChildren
  AdminLayoutTenantsRoute: typeof AdminLayoutTenantsRouteWithChildren
  AdminLayoutTicketsRoute: typeof AdminLayoutTicketsRouteWithChildren
  AdminLayoutAiUsageIndexRoute: typeof AdminLayoutAiUsageIndexRoute
  AdminLayoutInfrastructureCostsIndexRoute: typeof AdminLayoutInfrastructureCostsIndexRoute
  AdminLayoutReleasesIndexRoute: typeof AdminLayoutReleasesIndexRoute
}

const AdminLayoutRouteChildren: AdminLayoutRouteChildren = {
  AdminLayoutDashboardRoute: AdminLayoutDashboardRoute,
  AdminLayoutAcubeJobsRoute: AdminLayoutAcubeJobsRouteWithChildren,
  AdminLayoutAcubePaymentsRoute: AdminLayoutAcubePaymentsRouteWithChildren,
  AdminLayoutAdminsRoute: AdminLayoutAdminsRouteWithChildren,
  AdminLayoutAdvisorsRoute: AdminLayoutAdvisorsRouteWithChildren,
  AdminLayoutAppointeeRoute: AdminLayoutAppointeeRouteWithChildren,
  AdminLayoutCommissionsRoute: AdminLayoutCommissionsRouteWithChildren,
  AdminLayoutContractsRoute: AdminLayoutContractsRouteWithChildren,
  AdminLayoutErrorLogsRoute: AdminLayoutErrorLogsRouteWithChildren,
  AdminLayoutForeignVendorsRoute: AdminLayoutForeignVendorsRouteWithChildren,
  AdminLayoutMcpClientsRoute: AdminLayoutMcpClientsRouteWithChildren,
  AdminLayoutNotificationsRoute: AdminLayoutNotificationsRouteWithChildren,
  AdminLayoutReferrersRoute: AdminLayoutReferrersRouteWithChildren,
  AdminLayoutServiceUsageRoute: AdminLayoutServiceUsageRouteWithChildren,
  AdminLayoutSystemMonitorRoute: AdminLayoutSystemMonitorRouteWithChildren,
  AdminLayoutTenantsRoute: AdminLayoutTenantsRouteWithChildren,
  AdminLayoutTicketsRoute: AdminLayoutTicketsRouteWithChildren,
  AdminLayoutAiUsageIndexRoute: AdminLayoutAiUsageIndexRoute,
  AdminLayoutInfrastructureCostsIndexRoute:
    AdminLayoutInfrastructureCostsIndexRoute,
  AdminLayoutReleasesIndexRoute: AdminLayoutReleasesIndexRoute,
}

const AdminLayoutRouteWithChildren = AdminLayoutRoute._addFileChildren(
  AdminLayoutRouteChildren,
)

interface AdminRouteRouteChildren {
  AdminLayoutRoute: typeof AdminLayoutRouteWithChildren
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminLayoutRoute: AdminLayoutRouteWithChildren,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface ReferrerLayoutAgentsLayoutRouteChildren {
  ReferrerLayoutAgentsLayoutIdRoute: typeof ReferrerLayoutAgentsLayoutIdRoute
  ReferrerLayoutAgentsLayoutNewRoute: typeof ReferrerLayoutAgentsLayoutNewRoute
  ReferrerLayoutAgentsLayoutIndexRoute: typeof ReferrerLayoutAgentsLayoutIndexRoute
}

const ReferrerLayoutAgentsLayoutRouteChildren: ReferrerLayoutAgentsLayoutRouteChildren =
  {
    ReferrerLayoutAgentsLayoutIdRoute: ReferrerLayoutAgentsLayoutIdRoute,
    ReferrerLayoutAgentsLayoutNewRoute: ReferrerLayoutAgentsLayoutNewRoute,
    ReferrerLayoutAgentsLayoutIndexRoute: ReferrerLayoutAgentsLayoutIndexRoute,
  }

const ReferrerLayoutAgentsLayoutRouteWithChildren =
  ReferrerLayoutAgentsLayoutRoute._addFileChildren(
    ReferrerLayoutAgentsLayoutRouteChildren,
  )

interface ReferrerLayoutAgentsRouteChildren {
  ReferrerLayoutAgentsLayoutRoute: typeof ReferrerLayoutAgentsLayoutRouteWithChildren
}

const ReferrerLayoutAgentsRouteChildren: ReferrerLayoutAgentsRouteChildren = {
  ReferrerLayoutAgentsLayoutRoute: ReferrerLayoutAgentsLayoutRouteWithChildren,
}

const ReferrerLayoutAgentsRouteWithChildren =
  ReferrerLayoutAgentsRoute._addFileChildren(ReferrerLayoutAgentsRouteChildren)

interface ReferrerLayoutCommissionsLayoutRouteChildren {
  ReferrerLayoutCommissionsLayoutIdRoute: typeof ReferrerLayoutCommissionsLayoutIdRoute
  ReferrerLayoutCommissionsLayoutIndexRoute: typeof ReferrerLayoutCommissionsLayoutIndexRoute
}

const ReferrerLayoutCommissionsLayoutRouteChildren: ReferrerLayoutCommissionsLayoutRouteChildren =
  {
    ReferrerLayoutCommissionsLayoutIdRoute:
      ReferrerLayoutCommissionsLayoutIdRoute,
    ReferrerLayoutCommissionsLayoutIndexRoute:
      ReferrerLayoutCommissionsLayoutIndexRoute,
  }

const ReferrerLayoutCommissionsLayoutRouteWithChildren =
  ReferrerLayoutCommissionsLayoutRoute._addFileChildren(
    ReferrerLayoutCommissionsLayoutRouteChildren,
  )

interface ReferrerLayoutCommissionsRouteChildren {
  ReferrerLayoutCommissionsLayoutRoute: typeof ReferrerLayoutCommissionsLayoutRouteWithChildren
}

const ReferrerLayoutCommissionsRouteChildren: ReferrerLayoutCommissionsRouteChildren =
  {
    ReferrerLayoutCommissionsLayoutRoute:
      ReferrerLayoutCommissionsLayoutRouteWithChildren,
  }

const ReferrerLayoutCommissionsRouteWithChildren =
  ReferrerLayoutCommissionsRoute._addFileChildren(
    ReferrerLayoutCommissionsRouteChildren,
  )

interface ReferrerLayoutContractsLayoutRouteChildren {
  ReferrerLayoutContractsLayoutIdRoute: typeof ReferrerLayoutContractsLayoutIdRoute
  ReferrerLayoutContractsLayoutNewRoute: typeof ReferrerLayoutContractsLayoutNewRoute
  ReferrerLayoutContractsLayoutIndexRoute: typeof ReferrerLayoutContractsLayoutIndexRoute
  ReferrerLayoutContractsLayoutIdEditRoute: typeof ReferrerLayoutContractsLayoutIdEditRoute
}

const ReferrerLayoutContractsLayoutRouteChildren: ReferrerLayoutContractsLayoutRouteChildren =
  {
    ReferrerLayoutContractsLayoutIdRoute: ReferrerLayoutContractsLayoutIdRoute,
    ReferrerLayoutContractsLayoutNewRoute:
      ReferrerLayoutContractsLayoutNewRoute,
    ReferrerLayoutContractsLayoutIndexRoute:
      ReferrerLayoutContractsLayoutIndexRoute,
    ReferrerLayoutContractsLayoutIdEditRoute:
      ReferrerLayoutContractsLayoutIdEditRoute,
  }

const ReferrerLayoutContractsLayoutRouteWithChildren =
  ReferrerLayoutContractsLayoutRoute._addFileChildren(
    ReferrerLayoutContractsLayoutRouteChildren,
  )

interface ReferrerLayoutContractsRouteChildren {
  ReferrerLayoutContractsLayoutRoute: typeof ReferrerLayoutContractsLayoutRouteWithChildren
}

const ReferrerLayoutContractsRouteChildren: ReferrerLayoutContractsRouteChildren =
  {
    ReferrerLayoutContractsLayoutRoute:
      ReferrerLayoutContractsLayoutRouteWithChildren,
  }

const ReferrerLayoutContractsRouteWithChildren =
  ReferrerLayoutContractsRoute._addFileChildren(
    ReferrerLayoutContractsRouteChildren,
  )

interface ReferrerLayoutTenantsLayoutRouteChildren {
  ReferrerLayoutTenantsLayoutIdRoute: typeof ReferrerLayoutTenantsLayoutIdRoute
  ReferrerLayoutTenantsLayoutIndexRoute: typeof ReferrerLayoutTenantsLayoutIndexRoute
}

const ReferrerLayoutTenantsLayoutRouteChildren: ReferrerLayoutTenantsLayoutRouteChildren =
  {
    ReferrerLayoutTenantsLayoutIdRoute: ReferrerLayoutTenantsLayoutIdRoute,
    ReferrerLayoutTenantsLayoutIndexRoute:
      ReferrerLayoutTenantsLayoutIndexRoute,
  }

const ReferrerLayoutTenantsLayoutRouteWithChildren =
  ReferrerLayoutTenantsLayoutRoute._addFileChildren(
    ReferrerLayoutTenantsLayoutRouteChildren,
  )

interface ReferrerLayoutTenantsRouteChildren {
  ReferrerLayoutTenantsLayoutRoute: typeof ReferrerLayoutTenantsLayoutRouteWithChildren
}

const ReferrerLayoutTenantsRouteChildren: ReferrerLayoutTenantsRouteChildren = {
  ReferrerLayoutTenantsLayoutRoute:
    ReferrerLayoutTenantsLayoutRouteWithChildren,
}

const ReferrerLayoutTenantsRouteWithChildren =
  ReferrerLayoutTenantsRoute._addFileChildren(
    ReferrerLayoutTenantsRouteChildren,
  )

interface ReferrerLayoutRouteChildren {
  ReferrerLayoutDashboardRoute: typeof ReferrerLayoutDashboardRoute
  ReferrerLayoutInfrastructureCostsRoute: typeof ReferrerLayoutInfrastructureCostsRoute
  ReferrerLayoutReleasesRoute: typeof ReferrerLayoutReleasesRoute
  ReferrerLayoutAgentsRoute: typeof ReferrerLayoutAgentsRouteWithChildren
  ReferrerLayoutCommissionsRoute: typeof ReferrerLayoutCommissionsRouteWithChildren
  ReferrerLayoutContractsRoute: typeof ReferrerLayoutContractsRouteWithChildren
  ReferrerLayoutTenantsRoute: typeof ReferrerLayoutTenantsRouteWithChildren
}

const ReferrerLayoutRouteChildren: ReferrerLayoutRouteChildren = {
  ReferrerLayoutDashboardRoute: ReferrerLayoutDashboardRoute,
  ReferrerLayoutInfrastructureCostsRoute:
    ReferrerLayoutInfrastructureCostsRoute,
  ReferrerLayoutReleasesRoute: ReferrerLayoutReleasesRoute,
  ReferrerLayoutAgentsRoute: ReferrerLayoutAgentsRouteWithChildren,
  ReferrerLayoutCommissionsRoute: ReferrerLayoutCommissionsRouteWithChildren,
  ReferrerLayoutContractsRoute: ReferrerLayoutContractsRouteWithChildren,
  ReferrerLayoutTenantsRoute: ReferrerLayoutTenantsRouteWithChildren,
}

const ReferrerLayoutRouteWithChildren = ReferrerLayoutRoute._addFileChildren(
  ReferrerLayoutRouteChildren,
)

interface ReferrerRouteRouteChildren {
  ReferrerLayoutRoute: typeof ReferrerLayoutRouteWithChildren
}

const ReferrerRouteRouteChildren: ReferrerRouteRouteChildren = {
  ReferrerLayoutRoute: ReferrerLayoutRouteWithChildren,
}

const ReferrerRouteRouteWithChildren = ReferrerRouteRoute._addFileChildren(
  ReferrerRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  ReferrerRouteRoute: ReferrerRouteRouteWithChildren,
  AcceptInvitationRoute: AcceptInvitationRoute,
  PasswordResetRoute: PasswordResetRoute,
  ReleasesRoute: ReleasesRoute,
  SignInRoute: SignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
